import { a7 as e, a2 as t, ag as n, b as r, K as i, c as s, g as a, a as o, i as c, _ as u, S as l, a0 as h, t as d, aq as f, a5 as _, ar as v, x as p, y as m, ad as y, aj as b, ai as E, U as g, W as N, r as I, s as w, as as A, at as T } from "./__bundle-75942676.js";
import { U as O, s as C, v as S, j as L, k, l as R, m as x, n as D, F as P, o as M, b as B, D as H } from "./__bundle-e875840b.js";
import { S as U, U as V, F as K, b as q, c as F } from "./__bundle-84f74e8d.js";
var j, G, z;
!function (e) {
  e.LATEST_LAST_MESSAGE = "latest_last_message", e.CHRONOLOGICAL = "chronological", e.CHANNEL_NAME_ALPHABETICAL = "channel_name_alphabetical", e.METADATA_VALUE_ALPHABETICAL = "metadata_value_alphabetical";
}(j || (j = {})), function (e) {
  e.CHRONOLOGICAL = "chronological", e.CHANNEL_NAME_ALPHABETICAL = "channel_name_alphabetical", e.METADATA_VALUE_ALPHABETICAL = "metadata_value_alphabetical";
}(G || (G = {})), function (e) {
  e.CREATED_AT = "created_at", e.SCHEDULED_AT = "scheduled_at";
}(z || (z = {}));
var W,
  Y = function Y(e) {
    switch (e) {
      case j.LATEST_LAST_MESSAGE:
        return ["-lastMessageUpdatedAt", "-createdAt", "syncIndex"];
      case j.CHRONOLOGICAL:
        return ["-createdAt", "syncIndex"];
      case j.CHANNEL_NAME_ALPHABETICAL:
        return ["name"];
      default:
        return ["-lastMessageUpdatedAt", "-createdAt", "syncIndex"];
    }
  },
  Q = function () {
    function r() {
      this.messageTypeFilter = e.ALL, this.customTypesFilter = null, this.senderUserIdsFilter = null, this.replyType = n.NONE;
    }
    return r.prototype.clone = function () {
      var e = new r(),
        t = JSON.parse(JSON.stringify(this));
      return Object.keys(t).forEach(function (n) {
        e[n] = t[n];
      }), e;
    }, r.prototype.match = function (r) {
      switch (this.messageTypeFilter) {
        case e.USER:
          if (r.messageType !== t.USER) return !1;
          break;
        case e.FILE:
          if (r.messageType !== t.FILE) return !1;
          break;
        case e.ADMIN:
          if (r.messageType !== t.ADMIN) return !1;
      }
      if (this.customTypesFilter && this.customTypesFilter.length > 0 && !this.customTypesFilter.includes(r.customType)) return !1;
      if (this.senderUserIdsFilter && this.senderUserIdsFilter.length > 0) {
        if (!(r instanceof U)) return !1;
        if (!this.senderUserIdsFilter.includes(r.sender.userId)) return !1;
      }
      switch (this.replyType) {
        case n.NONE:
          if (r.parentMessageId > 0) return !1;
          break;
        case n.ONLY_REPLY_TO_CHANNEL:
          if (r instanceof U && r.parentMessageId > 0 && !r.replyToChannel) return !1;
      }
      return !0;
    }, r;
  }();
!function (e) {
  e.CHANNEL_LATEST = "channel_latest", e.NEWEST_CHILD_MESSAGE = "newest_child_message";
}(W || (W = {}));
var J,
  Z,
  X = function X(e) {
    switch (e) {
      case W.CHANNEL_LATEST:
        return ["channelUrl", "-createdAt", "-messageId"];
      case W.NEWEST_CHILD_MESSAGE:
        return ["channelUrl", "-parentMessageId", "-createdAt", "-messageId"];
    }
  },
  $ = function $() {
    return "undefined" != typeof document && "undefined" != typeof navigator && "ReactNative" !== navigator.product;
  },
  ee = function ee() {
    var e = new Date().getTime();
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (t) {
      var n = (e + 16 * Math.random()) % 16 | 0;
      return e = Math.floor(e / 16), ("x" === t ? n : 3 & n | 8).toString(16);
    });
  };
!function (e) {
  e[e.PROCESSING = 0] = "PROCESSING", e[e.DONE = 1] = "DONE";
}(J || (J = {})), function (e) {
  e.NEWNODE = "newnode", e.REMOVENODE = "removenode", e.CLAIM_HOST = "claimhost", e.SYNC_HOST = "synchost", e.REQUEST_LOCK = "requestlock", e.ACQUIRE_LOCK = "acquirelock", e.RELEASE_LOCK = "releaselock";
}(Z || (Z = {}));
var te,
  ne = {},
  re = function () {
    function e(e, t) {
      void 0 === t && (t = {});
      var n = this;
      return this._state = J.PROCESSING, this._queue = [], this._activationQueue = [], ne[e] && !t.forceCreate || (this.nodeId = ee(), this.key = e, $() && (t.startAsInvisible ? this.registerNode() : "visible" === document.visibilityState ? this.claimHost() : this.registerNode(), document.addEventListener("visibilitychange", function () {
        "visible" === document.visibilityState && n.claimHost();
      }), window.addEventListener("message", function (e) {
        var t,
          r,
          s = e.data,
          a = s.nodeId,
          o = s.requestId,
          c = s.key,
          u = s.op,
          l = s.data;
        if (a !== n.nodeId && c === n.key) switch (u) {
          case Z.NEWNODE:
            n._sendSync();
            break;
          case Z.CLAIM_HOST:
            n._sendSync(), n._hostId = a;
            break;
          case Z.SYNC_HOST:
            if (!n.isInSync) {
              n._activationTimeout && clearTimeout(n._activationTimeout);
              var h = l,
                d = h.currentItemRequestId,
                f = h.queue,
                _ = function _(e) {
                  var t = n._queue.findIndex(function (t) {
                    return t.requestId === e.requestId;
                  });
                  t < 0 && n._requestLock({
                    nodeId: e.nodeId,
                    requestId: e.requestId,
                    key: n.key,
                    op: Z.REQUEST_LOCK,
                    ts: e.ts
                  });
                };
              try {
                for (var v = i(f), p = v.next(); !p.done; p = v.next()) {
                  _(p.value);
                }
              } catch (e) {
                t = {
                  error: e
                };
              } finally {
                try {
                  p && !p.done && (r = v.return) && r.call(v);
                } finally {
                  if (t) throw t.error;
                }
              }
              n._currentItem = n._queue.find(function (e) {
                return e.requestId === d;
              }), n._completeSync();
            }
            break;
          case Z.REMOVENODE:
            n._queue = n._queue.filter(function (e) {
              return e.nodeId !== s.nodeId;
            }), n._currentItem && n._currentItem.nodeId === s.nodeId && (n._currentItem = void 0, n._acquire(n._queue[0]));
            break;
          case Z.REQUEST_LOCK:
            n._requestLock(s);
            break;
          case Z.ACQUIRE_LOCK:
            var m = n._queue.find(function (e) {
              return e.requestId === o;
            });
            n._acquire(m);
            break;
          case Z.RELEASE_LOCK:
            n._release(o);
        }
      }), window.addEventListener("beforeunload", function () {
        n._send(Z.REMOVENODE);
      })), ne[e] = this), ne[e];
    }
    return Object.defineProperty(e.prototype, "locked", {
      get: function get() {
        return !!this._currentItem;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "isHost", {
      get: function get() {
        return this._hostId === this.nodeId;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "isInSync", {
      get: function get() {
        return this._state == J.DONE;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype._send = function (e, t) {
      var n;
      void 0 === t && (t = {});
      var r = {
        nodeId: this.nodeId,
        requestId: null !== (n = null == t ? void 0 : t.requestId) && void 0 !== n ? n : ee(),
        key: this.key,
        op: e,
        data: t.data,
        ts: Date.now()
      };
      return $() && window.postMessage(r, "*"), r;
    }, e.prototype._acquire = function (e) {
      e ? (this._currentItem = e, this._currentItem.onAcquired && this._currentItem.onAcquired(e.requestId)) : this._currentItem = void 0;
    }, e.prototype._release = function (e) {
      if (this._currentItem && this._currentItem.requestId === e) {
        var t = this._currentItem;
        this._currentItem = void 0, t.nodeId === this.nodeId && this._send(Z.RELEASE_LOCK, {
          requestId: t.requestId
        });
        var n = this._queue.findIndex(function (t) {
          return t.requestId === e;
        });
        n > -1 && this._queue.splice(n, 1), t.onReleased && t.onReleased(e);
      }
    }, e.prototype._requestLock = function (e) {
      var t = this;
      return new Promise(function (n) {
        var r = {
            nodeId: e.nodeId,
            requestId: e.requestId,
            ts: e.ts,
            onAcquired: function onAcquired(e) {
              t.isHost && t._send(Z.ACQUIRE_LOCK, {
                requestId: e
              }), n();
            },
            onReleased: function onReleased() {
              t._acquire(t._queue[0]);
            }
          },
          i = !1;
        for (var s in t._queue) if (t._queue[s].ts > r.ts) {
          t._queue.splice(parseInt(s), 0, r), i = !0;
          break;
        }
        i || t._queue.push(r), t._currentItem || t._acquire(t._queue[0]);
      });
    }, e.prototype._sendSync = function () {
      var e;
      this.isHost && this._send(Z.SYNC_HOST, {
        data: {
          currentItemRequestId: null === (e = this._currentItem) || void 0 === e ? void 0 : e.requestId,
          queue: this._queue.map(function (e) {
            return {
              nodeId: e.nodeId,
              requestId: e.requestId,
              ts: e.ts
            };
          })
        }
      });
    }, e.prototype._waitUntilSyncCompleted = function () {
      return r(this, void 0, void 0, function () {
        var e = this;
        return s(this, function (t) {
          return this.isHost && !this.isInSync ? [2, new Promise(function (t) {
            e._activationQueue.push(t);
          })] : [2];
        });
      });
    }, e.prototype._waitSync = function () {
      var e = this;
      this.isInSync || (this._activationTimeout = setTimeout(function () {
        e._completeSync();
      }, 8));
    }, e.prototype._completeSync = function () {
      this.isInSync || (this._state = J.DONE, this._activationQueue.forEach(function (e) {
        return e();
      }), this._activationQueue = []);
    }, e.prototype.registerNode = function () {
      this._send(Z.NEWNODE), this._waitSync();
    }, e.prototype.claimHost = function () {
      this._hostId = this.nodeId, this._send(Z.CLAIM_HOST), this._waitSync();
    }, e.prototype.lock = function () {
      return r(this, void 0, void 0, function () {
        var e;
        return s(this, function (t) {
          switch (t.label) {
            case 0:
              return [4, this._waitUntilSyncCompleted()];
            case 1:
              return t.sent(), e = this._send(Z.REQUEST_LOCK), [4, this._requestLock(e)];
            case 2:
              return t.sent(), [2];
          }
        });
      });
    }, e.prototype.unlock = function () {
      var e;
      (null === (e = this._currentItem) || void 0 === e ? void 0 : e.requestId) && this._release(this._currentItem.requestId);
    }, e;
  }(),
  ie = a(a({}, O), {
    scheduledAt: void 0
  }),
  se = function se(e) {
    return S(e) && o("number", e.scheduledAt, !0);
  },
  ae = a(a({}, L), {
    scheduledAt: 0,
    file: void 0,
    fileUrl: void 0,
    fileName: void 0,
    mimeType: void 0,
    fileSize: void 0,
    thumbnailSizes: void 0,
    requireAuth: !1
  }),
  oe = function oe(e) {
    return R(e) && o("number", e.scheduledAt) && (c(e.file) || o("string", e.fileUrl)) && o("string", e.fileName, !0) && o("string", e.mimeType, !0) && o("number", e.fileSize, !0) && (null === e.thumbnailSizes || void 0 === e.thumbnailSizes || e.thumbnailSizes.every(function (e) {
      return o("object", e) && e.maxWidth > 0 && e.maxHeight > 0;
    }));
  },
  ce = "UnsentMessage",
  ue = "reqId",
  le = {},
  he = function (e) {
    function t(t, n) {
      var r = n.sdkState,
        i = n.cacheContext,
        s = e.call(this, t) || this;
      return s._sdkState = r, s._cacheContext = i, le[t] = s, s._mutex = new re("unsendmessagecache.lock"), s;
    }
    return u(t, e), t.of = function (e) {
      return le[e];
    }, Object.defineProperty(t.prototype, "collection", {
      get: function get() {
        var e = this._cacheContext.nestdb,
          t = null == e ? void 0 : e.collection(ce);
        if (!t) throw l.databaseError;
        return t;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "localCacheEnabled", {
      get: function get() {
        return this._cacheContext.localCacheEnabled && !!this.collection;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype._serialize = function (e) {
      if (e.messageId > 0) throw l.invalidParameters;
      var t,
        n = a({}, e.serialize());
      return e instanceof V ? (e.messageParams && (n.messageParams = C(e.messageParams)), e.scheduledInfo && e.scheduledInfo.scheduledMessageParams && (n.scheduledInfo.scheduledMessageParams = (t = e.scheduledInfo.scheduledMessageParams, a(a({}, C(t)), {
        scheduledAt: t.scheduledAt
      })))) : e instanceof K ? (e.messageParams && (n.messageParams = k(e.messageParams)), e.scheduledInfo && e.scheduledInfo.scheduledMessageParams && (n.scheduledInfo.scheduledMessageParams = function (e) {
        return a(a({}, k(e)), {
          scheduledAt: e.scheduledAt
        });
      }(e.scheduledInfo.scheduledMessageParams))) : e instanceof q && e.messageParams && (n.messageParams = x(e.messageParams)), n;
    }, t.prototype._deserialize = function (e) {
      return e = a(a({}, e), {
        messageId: parseInt(e.messageId)
      }), F.of(this._iid).buildMessageFromSerializedData(e);
    }, t.prototype._deserializeWithMessageCreateParams = function (e) {
      var t, n, i;
      return r(this, void 0, void 0, function () {
        var a,
          o,
          c,
          u,
          l,
          h,
          d = this;
        return s(this, function (f) {
          switch (f.label) {
            case 0:
              return a = F.of(this._iid), o = this._deserialize(e), e.messageParams ? o instanceof V ? (u = e.messageParams, o.messageParams = a.buildUserMessageCreateParamsFromSerializedData(u, o), [3, 6]) : [3, 1] : [3, 6];
            case 1:
              return o instanceof K ? (u = e.messageParams).fileKey && "string" == typeof u.fileKey && D(null !== (t = u.fileType) && void 0 !== t ? t : "") ? (c = u, [4, this.collection.getBlob(u.fileKey)]) : [3, 3] : [3, 4];
            case 2:
              c.file = null !== (n = f.sent()) && void 0 !== n ? n : void 0, f.label = 3;
            case 3:
              return o.messageParams = a.buildFileMessageCreateParamsFromSerializedData(u, o), [3, 6];
            case 4:
              return o instanceof q && (u = e.messageParams) && u.fileInfoList ? (o.messageParams = a.buildMultipleFilesMessageCreateParamsFromSerializedData(u, o), [4, Promise.all(o.messageParams.fileInfoList.map(function (e) {
                return r(d, void 0, void 0, function () {
                  var t, n, r, i, a;
                  return s(this, function (s) {
                    switch (s.label) {
                      case 0:
                        return "string" == typeof (null === (n = e._uploadedMetaData) || void 0 === n ? void 0 : n.fileKey) && D(null !== (i = null === (r = e._uploadedMetaData) || void 0 === r ? void 0 : r.fileType) && void 0 !== i ? i : "") ? (t = e, [4, this.collection.getBlob(e._uploadedMetaData.fileKey)]) : [3, 2];
                      case 1:
                        t.file = null !== (a = s.sent()) && void 0 !== a ? a : void 0, s.label = 2;
                      case 2:
                        return [2];
                    }
                  });
                });
              }))]) : [3, 6];
            case 5:
              f.sent(), f.label = 6;
            case 6:
              return o.scheduledInfo && e.scheduledInfo && e.scheduledInfo.scheduledMessageParams ? o instanceof V ? (l = e.scheduledInfo.scheduledMessageParams, o.scheduledInfo.scheduledMessageParams = a.buildScheduledUserMessageCreateParamsFromSerializedData(l, o), [3, 10]) : [3, 7] : [3, 10];
            case 7:
              return o instanceof K ? (l = e.scheduledInfo.scheduledMessageParams).fileKey && "string" == typeof l.fileKey && "string" == typeof l.fileType && D(l.fileType) ? (h = l, [4, this.collection.getBlob(l.fileKey)]) : [3, 9] : [3, 10];
            case 8:
              h.file = null !== (i = f.sent()) && void 0 !== i ? i : void 0, f.label = 9;
            case 9:
              o.scheduledInfo.scheduledMessageParams = a.buildScheduledFileMessageCreateParamsFromSerializedData(l, o), f.label = 10;
            case 10:
              return [2, o];
          }
        });
      });
    }, t.prototype._getFileInfoBlobKey = function (e, t) {
      return "".concat(e, ".").concat(t);
    }, t.prototype.get = function (e) {
      return r(this, void 0, void 0, function () {
        var t;
        return s(this, function (n) {
          switch (n.label) {
            case 0:
              return this.localCacheEnabled ? [4, this.collection.getByKey("".concat(e))] : [3, 2];
            case 1:
              if (t = n.sent()) return [2, this._deserializeWithMessageCreateParams(t)];
              n.label = 2;
            case 2:
              return [2, void 0];
          }
        });
      });
    }, t.prototype.fetch = function (e) {
      var t = e.channelUrl,
        n = e.filter,
        i = void 0 === n ? new Q() : n,
        a = e.order,
        o = void 0 === a ? W.CHANNEL_LATEST : a,
        c = e.sendingStatus,
        u = e.backward,
        l = void 0 !== u && u,
        h = e.parentMessageId;
      return r(this, void 0, void 0, function () {
        var e,
          n,
          a,
          u,
          d = this;
        return s(this, function (f) {
          switch (f.label) {
            case 0:
              return this.localCacheEnabled ? (e = X(o), n = {
                "/where": function where(e) {
                  return !!(o !== W.NEWEST_CHILD_MESSAGE || h && 0 !== e.parentMessageId && e.parentMessageId === h) && i.match(d._deserialize(e));
                }
              }, t && (n.channelUrl = t), c && (n.sendingStatus = c), a = {
                where: n,
                index: e,
                backward: l
              }, [4, this.collection.query(a)]) : [3, 3];
            case 1:
              return [4, f.sent().fetch({})];
            case 2:
              return u = f.sent(), [2, Promise.all(u.map(function (e) {
                return r(d, void 0, void 0, function () {
                  return s(this, function (t) {
                    switch (t.label) {
                      case 0:
                        return [4, this._deserializeWithMessageCreateParams(e)];
                      case 1:
                        return [2, t.sent()];
                    }
                  });
                });
              }))];
            case 3:
              return [2, []];
          }
        });
      });
    }, t.prototype.getAllChildMessages = function (e, t) {
      return void 0 === t && (t = new Q()), r(this, void 0, void 0, function () {
        return s(this, function (n) {
          switch (n.label) {
            case 0:
              return [4, this.fetch({
                filter: t,
                order: W.NEWEST_CHILD_MESSAGE,
                channelUrl: e.channelUrl,
                backward: !1,
                parentMessageId: e.messageId
              })];
            case 1:
              return [2, n.sent()];
          }
        });
      });
    }, t.prototype.upsert = function (e) {
      return r(this, void 0, void 0, function () {
        var t = this;
        return s(this, function (n) {
          switch (n.label) {
            case 0:
              return this.localCacheEnabled ? [4, Promise.all(e.map(function (e) {
                return r(t, void 0, void 0, function () {
                  var t;
                  return s(this, function (n) {
                    switch (n.label) {
                      case 0:
                        return e instanceof K || e instanceof q ? [4, this._mutex.lock()] : [3, 4];
                      case 1:
                        return n.sent(), [4, this.saveBlob(e)];
                      case 2:
                        return n.sent(), [4, this._mutex.unlock()];
                      case 3:
                        n.sent(), n.label = 4;
                      case 4:
                        return t = this._serialize(e), [4, this.collection.upsertOne(t)];
                      case 5:
                        return n.sent(), [2];
                    }
                  });
                });
              }))] : [3, 2];
            case 1:
              n.sent(), n.label = 2;
            case 2:
              return [2];
          }
        });
      });
    }, t.prototype.upsertChildMessages = function (e) {
      return r(this, void 0, void 0, function () {
        var t = this;
        return s(this, function (n) {
          switch (n.label) {
            case 0:
              return this.localCacheEnabled ? [4, Promise.all(e.map(function (e) {
                return r(t, void 0, void 0, function () {
                  var t;
                  return s(this, function (n) {
                    switch (n.label) {
                      case 0:
                        return t = [], e.threadInfo && e.threadInfo.replyCount > 0 ? [4, this.getAllChildMessages(e)] : [3, 2];
                      case 1:
                        t = n.sent(), n.label = 2;
                      case 2:
                        return t.length > 0 ? (t.forEach(function (t) {
                          return t.applyParentMessage(e);
                        }), [4, this.upsert(t)]) : [3, 4];
                      case 3:
                        n.sent(), n.label = 4;
                      case 4:
                        return [2];
                    }
                  });
                });
              }))] : [3, 2];
            case 1:
              n.sent(), n.label = 2;
            case 2:
              return [2];
          }
        });
      });
    }, t.prototype.remove = function (e) {
      return r(this, void 0, void 0, function () {
        var t, n, r, a, o, c;
        return s(this, function (s) {
          switch (s.label) {
            case 0:
              if (!this.localCacheEnabled) return [3, 8];
              s.label = 1;
            case 1:
              s.trys.push([1, 6, 7, 8]), t = i(e), n = t.next(), s.label = 2;
            case 2:
              return n.done ? [3, 5] : (r = n.value, [4, this.collection.remove(r)]);
            case 3:
              s.sent(), s.label = 4;
            case 4:
              return n = t.next(), [3, 2];
            case 5:
              return [3, 8];
            case 6:
              return a = s.sent(), o = {
                error: a
              }, [3, 8];
            case 7:
              try {
                n && !n.done && (c = t.return) && c.call(t);
              } finally {
                if (o) throw o.error;
              }
              return [7];
            case 8:
              return [2];
          }
        });
      });
    }, t.prototype.removeMessagesOfChannel = function (e) {
      return r(this, void 0, void 0, function () {
        return s(this, function (t) {
          switch (t.label) {
            case 0:
              return this.localCacheEnabled ? [4, this.collection.removeIf({
                where: {
                  channelUrl: e
                }
              })] : [3, 2];
            case 1:
              t.sent(), t.label = 2;
            case 2:
              return [2];
          }
        });
      });
    }, t.prototype.clear = function () {
      return r(this, void 0, void 0, function () {
        return s(this, function (e) {
          switch (e.label) {
            case 0:
              return this.localCacheEnabled ? [4, this.collection.clear()] : [3, 2];
            case 1:
              e.sent(), e.label = 2;
            case 2:
              return [2];
          }
        });
      });
    }, t.prototype.saveBlob = function (e) {
      return r(this, void 0, void 0, function () {
        var t,
          n,
          i,
          a = this;
        return s(this, function (o) {
          switch (o.label) {
            case 0:
              return e instanceof K ? e.messageParams && (i = e.messageParams).file && M(i.file) ? [4, this.collection.saveBlob(i.file, e.reqId)] : [3, 2] : [3, 5];
            case 1:
              n = o.sent(), i.fileKey = n, i.fileType = P.BLOB, o.label = 2;
            case 2:
              return e.scheduledInfo && e.scheduledInfo.scheduledMessageParams && (t = e.scheduledInfo.scheduledMessageParams).file && M(t.file) ? [4, this.collection.saveBlob(t.file, e.reqId)] : [3, 4];
            case 3:
              n = o.sent(), t.fileKey = n, t.fileType = P.BLOB, o.label = 4;
            case 4:
              return [3, 7];
            case 5:
              return e instanceof q && (i = e.messageParams) && i.fileInfoList && Array.isArray(i.fileInfoList) ? [4, Promise.all(i.fileInfoList.map(function (t, n) {
                return r(a, void 0, void 0, function () {
                  var r;
                  return s(this, function (i) {
                    switch (i.label) {
                      case 0:
                        return t.file && M(t.file) ? [4, this.collection.saveBlob(t.file, this._getFileInfoBlobKey(e.reqId, n))] : [3, 2];
                      case 1:
                        r = i.sent(), t._uploadedMetaData || (t._uploadedMetaData = {}), t._uploadedMetaData.fileKey = r, t._uploadedMetaData.fileType = P.BLOB, i.label = 2;
                      case 2:
                        return [2];
                    }
                  });
                });
              }))] : [3, 7];
            case 6:
              o.sent(), o.label = 7;
            case 7:
              return [2];
          }
        });
      });
    }, t;
  }(h),
  de = {},
  fe = function (e) {
    function t(t, n) {
      var r = n.sdkState,
        i = n.cacheContext,
        s = n.unsentMessageCache,
        a = e.call(this, t) || this;
      return a._sdkState = r, a._cacheContext = i, a._unsentMessageCache = s, de[t] = a, a;
    }
    return u(t, e), t.of = function (e) {
      return de[e];
    }, Object.defineProperty(t.prototype, "collection", {
      get: function get() {
        var e = this._cacheContext.nestdb;
        return d(!!e).throw(l.databaseError), e.collection(B);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "localCacheEnabled", {
      get: function get() {
        return this._cacheContext.localCacheEnabled && !!this.collection;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype._serialize = function (e) {
      return a(a({}, e.serialize()), {
        messageId: "".concat(e.messageId)
      });
    }, t.prototype._deserialize = function (e) {
      return e = a(a({}, e), {
        messageId: parseInt(e.messageId)
      }), F.of(this._iid).buildMessageFromSerializedData(e);
    }, t.prototype.get = function (e) {
      return r(this, void 0, void 0, function () {
        var t;
        return s(this, function (n) {
          switch (n.label) {
            case 0:
              return this.localCacheEnabled ? [4, this.collection.getByKey("".concat(e))] : [3, 2];
            case 1:
              if (t = n.sent()) return [2, this._deserialize(t)];
              n.label = 2;
            case 2:
              return [2, void 0];
          }
        });
      });
    }, t.prototype.fetch = function (e) {
      var t = e.channelUrl,
        n = e.token,
        i = e.limit,
        a = void 0 === i ? H : i,
        o = e.filter,
        c = void 0 === o ? new Q() : o,
        u = e.order,
        l = void 0 === u ? W.CHANNEL_LATEST : u,
        h = e.backward,
        d = void 0 !== h && h,
        f = e.parentMessageId,
        _ = e.isPollOnly,
        v = void 0 !== _ && _;
      return r(this, void 0, void 0, function () {
        var e,
          i,
          o,
          u = this;
        return s(this, function (h) {
          switch (h.label) {
            case 0:
              return this.localCacheEnabled ? (e = X(l), i = {
                where: {
                  channelUrl: t,
                  "/where": function where(e) {
                    if (n) switch (l) {
                      case W.CHANNEL_LATEST:
                        if (!d && e.createdAt > n || d && e.createdAt < n) return !1;
                        break;
                      case W.NEWEST_CHILD_MESSAGE:
                        if (!f || 0 === e.parentMessageId || e.parentMessageId !== f) return !1;
                    }
                    return !(v && !e._poll) && c.match(u._deserialize(e));
                  }
                },
                index: e,
                backward: d
              }, [4, this.collection.query(i)]) : [3, 3];
            case 1:
              return [4, h.sent().fetch({
                limit: null != a ? a : void 0
              })];
            case 2:
              return o = h.sent(), [2, Promise.all(o.map(function (e) {
                return r(u, void 0, void 0, function () {
                  return s(this, function (t) {
                    return [2, this._deserialize(e)];
                  });
                });
              }))];
            case 3:
              return [2, []];
          }
        });
      });
    }, t.prototype.getAllChildMessages = function (e, t) {
      return void 0 === t && (t = new Q()), r(this, void 0, void 0, function () {
        return s(this, function (n) {
          switch (n.label) {
            case 0:
              return [4, this.fetch({
                channelUrl: e.channelUrl,
                token: Date.now(),
                limit: null,
                backward: !1,
                filter: t,
                order: W.NEWEST_CHILD_MESSAGE,
                parentMessageId: e.messageId
              })];
            case 1:
              return [2, n.sent()];
          }
        });
      });
    }, t.prototype.upsert = function (e) {
      return r(this, void 0, void 0, function () {
        var t,
          n = this;
        return s(this, function (r) {
          switch (r.label) {
            case 0:
              return this.localCacheEnabled ? [4, this.saveBlobs(e)] : [3, 5];
            case 1:
              return r.sent(), t = e.map(function (e) {
                return n._serialize(e);
              }), [4, this.collection.upsertMany(t)];
            case 2:
              return r.sent(), [4, this.upsertChildMessages(e)];
            case 3:
              return r.sent(), [4, this._unsentMessageCache.upsertChildMessages(e)];
            case 4:
              r.sent(), r.label = 5;
            case 5:
              return [2];
          }
        });
      });
    }, t.prototype.upsertChildMessages = function (e) {
      return r(this, void 0, void 0, function () {
        var t = this;
        return s(this, function (n) {
          switch (n.label) {
            case 0:
              return this.localCacheEnabled ? [4, Promise.all(e.map(function (e) {
                return r(t, void 0, void 0, function () {
                  var t, n;
                  return s(this, function (r) {
                    switch (r.label) {
                      case 0:
                        return t = [], (null === (n = e.threadInfo) || void 0 === n ? void 0 : n.replyCount) && e.threadInfo.replyCount > 0 ? [4, this.getAllChildMessages(e)] : [3, 2];
                      case 1:
                        t = r.sent(), r.label = 2;
                      case 2:
                        return t.length > 0 ? (t.forEach(function (t) {
                          return t.applyParentMessage(e);
                        }), [4, this.upsert(t)]) : [3, 4];
                      case 3:
                        r.sent(), r.label = 4;
                      case 4:
                        return [2];
                    }
                  });
                });
              }))] : [3, 2];
            case 1:
              n.sent(), n.label = 2;
            case 2:
              return [2];
          }
        });
      });
    }, t.prototype.remove = function (e) {
      return r(this, void 0, void 0, function () {
        var t, n, r, a, o, c;
        return s(this, function (s) {
          switch (s.label) {
            case 0:
              if (!this.localCacheEnabled) return [3, 8];
              s.label = 1;
            case 1:
              s.trys.push([1, 6, 7, 8]), t = i(e), n = t.next(), s.label = 2;
            case 2:
              return n.done ? [3, 5] : (r = n.value, [4, this.collection.remove("".concat(r))]);
            case 3:
              s.sent(), s.label = 4;
            case 4:
              return n = t.next(), [3, 2];
            case 5:
              return [3, 8];
            case 6:
              return a = s.sent(), o = {
                error: a
              }, [3, 8];
            case 7:
              try {
                n && !n.done && (c = t.return) && c.call(t);
              } finally {
                if (o) throw o.error;
              }
              return [7];
            case 8:
              return [2];
          }
        });
      });
    }, t.prototype.removeMessagesOfChannel = function (e) {
      return r(this, void 0, void 0, function () {
        var t;
        return s(this, function (n) {
          switch (n.label) {
            case 0:
              return this.localCacheEnabled ? [4, this.collection.removeIf({
                where: {
                  channelUrl: e
                },
                index: X(W.CHANNEL_LATEST)
              })] : [3, 6];
            case 1:
              return n.sent(), [4, (t = this._cacheContext.preference).remove("sendbird:".concat(this._sdkState.userId, "@groupchannel/").concat(e, "/message/sync"))];
            case 2:
              return n.sent(), [4, t.remove("sendbird:".concat(this._sdkState.userId, "@groupchannel/").concat(e, "/message/sync.meta"))];
            case 3:
              return n.sent(), [4, t.remove("sendbird:".concat(this._sdkState.userId, "@groupchannel/").concat(e, "/message/changelogs"))];
            case 4:
              return n.sent(), [4, t.remove("sendbird:".concat(this._sdkState.userId, "@groupchannel/").concat(e, "/message/changelogs.meta"))];
            case 5:
              n.sent(), n.label = 6;
            case 6:
              return [2];
          }
        });
      });
    }, t.prototype.removeUnderOffset = function (e, t) {
      return r(this, void 0, void 0, function () {
        return s(this, function (n) {
          switch (n.label) {
            case 0:
              return this.localCacheEnabled ? [4, this.collection.removeIf({
                where: {
                  channelUrl: e,
                  createdAt: {
                    "<": t
                  }
                },
                index: X(W.CHANNEL_LATEST)
              })] : [3, 2];
            case 1:
              n.sent(), n.label = 2;
            case 2:
              return [2];
          }
        });
      });
    }, t.prototype.clear = function () {
      return r(this, void 0, void 0, function () {
        return s(this, function (e) {
          switch (e.label) {
            case 0:
              return this.localCacheEnabled ? [4, this.collection.clear()] : [3, 2];
            case 1:
              e.sent(), e.label = 2;
            case 2:
              return [2];
          }
        });
      });
    }, t.prototype.countBetween = function (e, t, n) {
      return r(this, void 0, void 0, function () {
        var r,
          i = this;
        return s(this, function (s) {
          switch (s.label) {
            case 0:
              return this.localCacheEnabled ? (r = X(W.CHANNEL_LATEST), [4, this.collection.query({
                where: {
                  channelUrl: e,
                  "/where": function where(e) {
                    var r = i._deserialize(e);
                    return n.includes(r.createdAt) && t.match(r);
                  }
                },
                index: r
              }).count()]) : [3, 2];
            case 1:
              return [2, s.sent()];
            case 2:
              return [2, 0];
          }
        });
      });
    }, t.prototype.saveBlobs = function (e) {
      return r(this, void 0, void 0, function () {
        var t = this;
        return s(this, function (n) {
          switch (n.label) {
            case 0:
              return [4, Promise.all(e.map(function (e) {
                return r(t, void 0, void 0, function () {
                  var t, n;
                  return s(this, function (r) {
                    switch (r.label) {
                      case 0:
                        return e instanceof K && e.messageParams && (t = e.messageParams).file && M(t.file) ? [4, this.collection.saveBlob(t.file, e.reqId)] : [3, 2];
                      case 1:
                        n = r.sent(), t.fileKey = n, r.label = 2;
                      case 2:
                        return [2];
                    }
                  });
                });
              }))];
            case 1:
              return n.sent(), [2];
          }
        });
      });
    }, t.prototype._getGroupChannelPreferenceSize = function (e) {
      return r(this, void 0, void 0, function () {
        var t, n, r, i, a, o;
        return s(this, function (s) {
          switch (s.label) {
            case 0:
              return t = 0, [4, (n = this._cacheContext.preference).get("sendbird:".concat(this._sdkState.userId, "@groupchannel/").concat(e, "/message/sync"))];
            case 1:
              return r = s.sent(), [4, n.get("sendbird:".concat(this._sdkState.userId, "@groupchannel/").concat(e, "/message/sync.meta"))];
            case 2:
              return i = s.sent(), [4, n.get("sendbird:".concat(this._sdkState.userId, "@groupchannel/").concat(e, "/message/changelogs"))];
            case 3:
              return a = s.sent(), [4, n.get("sendbird:".concat(this._sdkState.userId, "@groupchannel/").concat(e, "/message/changelogs.meta"))];
            case 4:
              return o = s.sent(), r && (t += JSON.stringify(r).length), i && (t += JSON.stringify(i).length), a && (t += JSON.stringify(a).length), o && (t += JSON.stringify(o).length), [2, t];
          }
        });
      });
    }, t;
  }(h),
  _e = function (e) {
    function t(t) {
      var n = t.message,
        r = e.call(this) || this;
      return r.message = n, r;
    }
    return u(t, e), t;
  }(f),
  ve = {},
  pe = function () {
    function e(e, t) {
      var n = t.localCacheEnabled,
        r = t.dispatcher,
        i = t.sdkState,
        s = t.logger,
        a = this;
      this._iid = e, ve[e] = this, this._localCacheEnabled = n, this._isProcessingAutoResend = !1, this._autoResendQueue = [], this._dispatcher = r, this._logger = s, this._sdkState = i, this._localCacheEnabled && r.on(function (e) {
        if (e instanceof p) switch (e.stateType) {
          case m.CONNECTED:
            a._isProcessingAutoResend || a.processAutoResendRegisteredPendingMessages().then(function () {
              return a._processNextAutoResend();
            });
            break;
          case m.INTERNAL_DISCONNECTED:
          case m.EXTERNAL_DISCONNECTED:
            a._isProcessingAutoResend = !1;
        }
      });
    }
    return e.of = function (e) {
      return ve[e];
    }, e.prototype.processNonAutoResendRegisteredPendingMessages = function () {
      return r(this, void 0, void 0, function () {
        var e, t, n, r, a, o;
        return s(this, function (s) {
          switch (s.label) {
            case 0:
              return [4, this._fetchAllCachedPendingMessages()];
            case 1:
              e = s.sent();
              try {
                for (t = i(e), n = t.next(); !n.done; n = t.next()) 0 === (r = n.value).errorCode && (this._logger.debug("cached pending message is not auto-resend registered. changing its sending status to failed: ", r.reqId), r.sendingStatus = _.FAILED, r.errorCode = y.ACK_TIMEOUT, this._dispatcher.dispatch(new b({
                  messages: [r],
                  source: E.LOCAL_MESSAGE_FAILED
                })));
              } catch (e) {
                a = {
                  error: e
                };
              } finally {
                try {
                  n && !n.done && (o = t.return) && o.call(t);
                } finally {
                  if (a) throw a.error;
                }
              }
              return [2];
          }
        });
      });
    }, e.prototype.processAutoResendRegisteredPendingMessages = function () {
      return r(this, void 0, void 0, function () {
        var e, t, n, r, a, o, c, u;
        return s(this, function (s) {
          switch (s.label) {
            case 0:
              return [4, this._fetchAllCachedPendingMessages()];
            case 1:
              e = s.sent();
              try {
                for (t = i(e), n = t.next(); !n.done; n = t.next()) (r = n.value).errorCode && v(r.errorCode) && (a = new Date().getTime(), o = r.createdAt + 2592e5, a <= o ? this._autoResendQueue.map(function (e) {
                  return e.reqId;
                }).indexOf(r.reqId) < 0 && this._autoResendQueue.push(r) : (this._logger.debug("auto-resend registered pending messaged expired. expiration date: ", new Date(o).toLocaleString()), r.sendingStatus = _.FAILED, this._dispatcher.dispatch(new b({
                  messages: [r],
                  source: E.LOCAL_MESSAGE_FAILED
                }))));
              } catch (e) {
                c = {
                  error: e
                };
              } finally {
                try {
                  n && !n.done && (u = t.return) && u.call(t);
                } finally {
                  if (c) throw c.error;
                }
              }
              return [2];
          }
        });
      });
    }, e.prototype.completeCurrentAndProcessNextAutoResend = function (e) {
      if (this._localCacheEnabled && (e.sendingStatus === _.SUCCEEDED || e.sendingStatus === _.FAILED && !v(e.errorCode))) {
        var t = this.indexOf(e);
        t >= 0 && this._autoResendQueue.splice(t, 1), 0 === t && this._processNextAutoResend();
      }
    }, e.prototype._fetchAllCachedPendingMessages = function () {
      return r(this, void 0, void 0, function () {
        var e, t;
        return s(this, function (n) {
          switch (n.label) {
            case 0:
              return (e = he.of(this._iid)) ? [4, e.fetch({
                sendingStatus: _.PENDING,
                backward: !0
              })] : [3, 2];
            case 1:
              return t = n.sent(), [3, 3];
            case 2:
              t = [], n.label = 3;
            case 3:
              return [2, t];
          }
        });
      });
    }, e.prototype.indexOf = function (e) {
      return this._autoResendQueue.length > 0 ? this._autoResendQueue.map(function (e) {
        return e.reqId;
      }).indexOf(e.reqId) : -1;
    }, e.prototype._isNotInQueue = function (e) {
      return -1 === this._autoResendQueue.map(function (e) {
        return e.reqId;
      }).indexOf(e.reqId);
    }, e.prototype._processNextAutoResend = function () {
      return r(this, void 0, void 0, function () {
        var e;
        return s(this, function (t) {
          if (this._localCacheEnabled && "foreground" === this._sdkState.appState) try {
            this._autoResendQueue.length > 0 ? (this._isProcessingAutoResend || (this._logger.debug("auto-resend queue started."), this._isProcessingAutoResend = !0), e = this._autoResendQueue[0], this._dispatcher.dispatch(new _e({
              message: e
            })), this._logger.debug("processing auto-resend for message request id: ", e.reqId)) : (this._logger.debug("auto-resend queue finished."), this._isProcessingAutoResend = !1);
          } catch (e) {
            this._logger.warn("process auto-resend error: ", e), this._isProcessingAutoResend = !1;
          }
          return [2];
        });
      });
    }, e;
  }();
!function (e) {
  e[e.USER_BLOCK = 20001] = "USER_BLOCK", e[e.USER_UNBLOCK = 2e4] = "USER_UNBLOCK", e[e.FRIEND_DISCOVERED = 20900] = "FRIEND_DISCOVERED";
}(te || (te = {}));
var me,
  ye = function () {
    function e(e) {
      this.category = e.cat, this.data = e.data;
    }
    return e.getDataAsUserBlockEvent = function (e, t) {
      var n = t.data,
        r = n.blocker,
        i = n.blockee;
      return {
        blocker: new g(e, r),
        blockee: new g(e, i)
      };
    }, e.getDataAsFriendDiscoveredEvent = function (e, t) {
      var n = t.data.friend_discoveries;
      return {
        friendDiscoveries: Array.isArray(n) ? n.map(function (t) {
          return new g(e, t);
        }) : []
      };
    }, e;
  }(),
  be = function (e) {
    function t(t, n) {
      var r = n.userId,
        i = e.call(this) || this;
      return i._iid = t, i.userId = r, i;
    }
    return u(t, e), t;
  }(f);
!function (e) {
  e.UNKNOWN = "UNKNOWN", e.EVENT_CHANNEL_CREATED = "EVENT_CHANNEL_CREATED", e.EVENT_CHANNEL_UPDATED = "EVENT_CHANNEL_UPDATED", e.EVENT_CHANNEL_DELETED = "EVENT_CHANNEL_DELETED", e.EVENT_CHANNEL_READ = "EVENT_CHANNEL_READ", e.EVENT_CHANNEL_DELIVERED = "EVENT_CHANNEL_DELIVERED", e.EVENT_CHANNEL_INVITED = "EVENT_CHANNEL_INVITED", e.EVENT_CHANNEL_JOINED = "EVENT_CHANNEL_JOINED", e.EVENT_CHANNEL_LEFT = "EVENT_CHANNEL_LEFT", e.EVENT_CHANNEL_ACCEPTED_INVITE = "EVENT_CHANNEL_ACCEPTED_INVITE", e.EVENT_CHANNEL_DECLINED_INVITE = "EVENT_CHANNEL_DECLINED_INVITE", e.EVENT_CHANNEL_OPERATOR_UPDATED = "EVENT_CHANNEL_OPERATOR_UPDATED", e.EVENT_CHANNEL_MUTED = "EVENT_CHANNEL_MUTED", e.EVENT_CHANNEL_UNMUTED = "EVENT_CHANNEL_UNMUTED", e.EVENT_CHANNEL_FROZEN = "EVENT_CHANNEL_FROZEN", e.EVENT_CHANNEL_UNFROZEN = "EVENT_CHANNEL_UNFROZEN", e.EVENT_CHANNEL_HIDDEN = "EVENT_CHANNEL_HIDDEN", e.EVENT_CHANNEL_UNHIDDEN = "EVENT_CHANNEL_UNHIDDEN", e.EVENT_CHANNEL_RESET_HISTORY = "EVENT_CHANNEL_RESET_HISTORY", e.EVENT_CHANNEL_TYPING_STATUS_UPDATE = "EVENT_CHANNEL_TYPING_STATUS_UPDATE", e.EVENT_CHANNEL_MEMBER_COUNT_UPDATED = "EVENT_CHANNEL_MEMBER_COUNT_UPDATED", e.EVENT_MESSAGE_SENT = "EVENT_MESSAGE_SENT", e.EVENT_MESSAGE_RECEIVED = "EVENT_MESSAGE_RECEIVED", e.EVENT_MESSAGE_UPDATED = "EVENT_MESSAGE_UPDATED", e.EVENT_PINNED_MESSAGE_UPDATED = "EVENT_PINNED_MESSAGE_UPDATED", e.REQUEST_CHANNEL = "REQUEST_CHANNEL", e.REQUEST_CHANNEL_CHANGELOGS = "REQUEST_CHANNEL_CHANGELOGS", e.REFRESH_CHANNEL = "REFRESH_CHANNEL", e.CHANNEL_LASTACCESSEDAT_UPDATED = "CHANNEL_LASTACCESSEDAT_UPDATED", e.SYNC_CHANNEL_BACKGROUND = "SYNC_CHANNEL_BACKGROUND", e.SYNC_CHANNEL_CHANGELOGS = "SYNC_CHANNEL_CHANGELOGS";
}(me || (me = {}));
var Ee,
  ge = function ge(e) {
    return e.startsWith("EVENT_") || e === me.SYNC_CHANNEL_CHANGELOGS || e === me.REFRESH_CHANNEL;
  },
  Ne = function (e) {
    function t(t) {
      var n = t.channels,
        r = t.source,
        i = t.isWebSocketEventComing,
        s = void 0 !== i && i,
        a = t.data,
        o = void 0 === a ? null : a,
        c = e.call(this) || this;
      return c.channels = n, c.source = r, c.isWebSocketEventComing = s, c.data = o, c;
    }
    return u(t, e), t;
  }(f),
  Ie = function (e) {
    function t(t) {
      var n = t.channelUrls,
        r = t.source,
        i = t.isWebSocketEventComing,
        s = void 0 !== i && i,
        a = e.call(this) || this;
      return a.channelUrls = n, a.source = r, a.isWebSocketEventComing = s, a;
    }
    return u(t, e), t;
  }(f),
  we = function (e) {
    function t() {
      return e.call(this) || this;
    }
    return u(t, e), t;
  }(f),
  Ae = function (e) {
    function t(t, n, r) {
      var i = e.call(this, t, "USEV", r) || this;
      return i.event = new ye(r), i;
    }
    return u(t, e), t;
  }(N),
  Te = {},
  Oe = function () {
    function e(e) {
      var t = e.dbname,
        n = e.itemSizeLimit,
        r = void 0 === n ? 1048576 : n,
        i = e.cacheLimit,
        s = void 0 === i ? 256 : i,
        a = e.blockHashBase,
        o = void 0 === a ? 2 : a,
        c = e.blockHashMultiplier,
        u = void 0 === c ? 10 : c,
        l = e.blockHashConstant,
        h = void 0 === l ? 11 : l,
        d = e.transactionApplyDelay,
        f = void 0 === d ? 200 : d,
        _ = e.disableLogger,
        v = void 0 !== _ && _;
      return Te[t] || (this.itemSizeLimit = r, this.cacheLimit = s, this.blockHashBase = o, this.blockHashMultiplier = u, this.blockHashConstant = h, this.transactionApplyDelay = f, this.disableLogger = v, Te[t] = this), Te[t];
    }
    return e.get = function (e) {
      return Te[e];
    }, e;
  }();
!function (e) {
  e[e.UNKNOWN_ERROR = 6e7] = "UNKNOWN_ERROR", e[e.STORE_NOT_DEFINED = 61001e3] = "STORE_NOT_DEFINED", e[e.STORE_NOT_AVAILABLE = 61001001] = "STORE_NOT_AVAILABLE", e[e.STORE_NOT_AVAILABLE_IN_PRIVATE_BROWSING = 61001002] = "STORE_NOT_AVAILABLE_IN_PRIVATE_BROWSING", e[e.STORE_IS_FULL = 61001003] = "STORE_IS_FULL", e[e.STORE_NOT_INITIALIZED = 61001004] = "STORE_NOT_INITIALIZED", e[e.STORE_INVALID_KEY_TYPE = 61002e3] = "STORE_INVALID_KEY_TYPE", e[e.STORE_BROKEN_INTEGRITY = 61002001] = "STORE_BROKEN_INTEGRITY", e[e.STORE_BROKEN_BLOB = 61002002] = "STORE_BROKEN_BLOB", e[e.STORE_ENCRYPTION_INVALID = 61002003] = "STORE_ENCRYPTION_INVALID", e[e.STORE_ITEM_SIZE_LIMIT_EXCEEDED = 61017e3] = "STORE_ITEM_SIZE_LIMIT_EXCEEDED", e[e.STORE_READ_FAILED = 61017001] = "STORE_READ_FAILED", e[e.STORE_WRITE_FAILED = 61017002] = "STORE_WRITE_FAILED", e[e.DATABASE_SCHEMA_NOT_ON_UPGRADE = 62002e3] = "DATABASE_SCHEMA_NOT_ON_UPGRADE", e[e.COLLECTION_NOT_READY = 63001e3] = "COLLECTION_NOT_READY", e[e.COLLECTION_KEY_NOT_MATCH = 63002e3] = "COLLECTION_KEY_NOT_MATCH", e[e.COLLECTION_QUERY_NOT_VALID = 63002001] = "COLLECTION_QUERY_NOT_VALID", e[e.COLLECTION_KEY_NOT_FOUND = 63004e3] = "COLLECTION_KEY_NOT_FOUND", e[e.COLLECTION_KEY_NOT_GIVEN = 63004001] = "COLLECTION_KEY_NOT_GIVEN", e[e.COLLECTION_INSERT_DUPLICATE = 63009e3] = "COLLECTION_INSERT_DUPLICATE", e[e.COLLECTION_WRITE_FAILED = 63017e3] = "COLLECTION_WRITE_FAILED", e[e.COLLECTION_ITEM_SIZE_LIMIT_EXCEEDED = 63017001] = "COLLECTION_ITEM_SIZE_LIMIT_EXCEEDED", e[e.INDEX_TABLE_IS_REQUIRED = 65001e3] = "INDEX_TABLE_IS_REQUIRED", e[e.INDEX_TYPE_NOT_MATCH = 65002e3] = "INDEX_TYPE_NOT_MATCH", e[e.COMPARE_TYPE_NOT_MATCH = 69002001] = "COMPARE_TYPE_NOT_MATCH", e[e.CIRCULAR_REFERENCE_FOUND = 69002002] = "CIRCULAR_REFERENCE_FOUND";
}(Ee || (Ee = {}));
var Ce,
  Se = function (e) {
    function t(n) {
      var r = n.code,
        i = void 0 === r ? Ee.UNKNOWN_ERROR : r,
        s = n.message,
        a = void 0 === s ? "Unknown error occurred." : s,
        o = e.call(this, a) || this;
      return o.code = i, Object.setPrototypeOf(o, t.prototype), o;
    }
    return u(t, e), Object.defineProperty(t, "storeNotDefined", {
      get: function get() {
        return new t({
          code: Ee.STORE_NOT_DEFINED,
          message: "Store is not defined. Specify the store on NestDB()"
        });
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t, "storeNotAvailable", {
      get: function get() {
        return new t({
          code: Ee.STORE_NOT_AVAILABLE,
          message: "Store is not available. Check your environment settings."
        });
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t, "storeNotAvailableInPrivateBrowsing", {
      get: function get() {
        return new t({
          code: Ee.STORE_NOT_AVAILABLE_IN_PRIVATE_BROWSING,
          message: "Store is not available because it is in private browsing."
        });
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t, "storeIsFull", {
      get: function get() {
        return new t({
          code: Ee.STORE_IS_FULL,
          message: "Store is full."
        });
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t, "storeNotInitialized", {
      get: function get() {
        return new t({
          code: Ee.STORE_NOT_INITIALIZED,
          message: "Store is not initialized."
        });
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t, "storeKeyTypeIsInvalid", {
      get: function get() {
        return new t({
          code: Ee.STORE_INVALID_KEY_TYPE,
          message: "Store key should be string type."
        });
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t, "storeBrokenIntegrity", {
      get: function get() {
        return new t({
          code: Ee.STORE_BROKEN_INTEGRITY,
          message: "Data should be in a store but it does not. Integrity is broken."
        });
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t, "storeBrokenBlob", {
      get: function get() {
        return new t({
          code: Ee.STORE_BROKEN_BLOB,
          message: "Data should be in a store but it does not. Blob data is broken."
        });
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t, "storeEncryptionInvalid", {
      get: function get() {
        return new t({
          code: Ee.STORE_ENCRYPTION_INVALID,
          message: "Encryption algorithm has changed. All the store should reset."
        });
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t, "storeItemSizeExceeded", {
      get: function get() {
        return new t({
          code: Ee.STORE_ITEM_SIZE_LIMIT_EXCEEDED,
          message: "The size of the item exceeds the limit that the store allows."
        });
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t, "storeReadFailed", {
      get: function get() {
        return new t({
          code: Ee.STORE_READ_FAILED,
          message: "Failed to read from store."
        });
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t, "storeWriteFailed", {
      get: function get() {
        return new t({
          code: Ee.STORE_WRITE_FAILED,
          message: "Failed to write to store."
        });
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t, "databaseSchemaNotOnUpgrade", {
      get: function get() {
        return new t({
          code: Ee.DATABASE_SCHEMA_NOT_ON_UPGRADE,
          message: "Committing schema is not allowed when upgrade is not running."
        });
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t, "collectionNotReady", {
      get: function get() {
        return new t({
          code: Ee.COLLECTION_NOT_READY,
          message: "Collection is not ready due to an error during initialization."
        });
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t, "collectionKeyNotMatch", {
      get: function get() {
        return new t({
          code: Ee.COLLECTION_KEY_NOT_MATCH,
          message: "keyName of collection could not change."
        });
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t, "collectionQueryNotValid", {
      get: function get() {
        return new t({
          code: Ee.COLLECTION_QUERY_NOT_VALID,
          message: "Query parameter is not a valid format."
        });
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t, "collectionInsertDuplicate", {
      get: function get() {
        return new t({
          code: Ee.COLLECTION_INSERT_DUPLICATE,
          message: "The key already exists."
        });
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t, "collectionKeyNotFound", {
      get: function get() {
        return new t({
          code: Ee.COLLECTION_KEY_NOT_FOUND,
          message: "The key is not found."
        });
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t, "collectionKeyNotGiven", {
      get: function get() {
        return new t({
          code: Ee.COLLECTION_KEY_NOT_GIVEN,
          message: "The item should contain [keyName] property."
        });
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t, "collectionWriteFailed", {
      get: function get() {
        return new t({
          code: Ee.COLLECTION_WRITE_FAILED,
          message: "Failed to write an item."
        });
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t, "collectionItemSizeExceeded", {
      get: function get() {
        return new t({
          code: Ee.COLLECTION_ITEM_SIZE_LIMIT_EXCEEDED,
          message: "The size of the item exceeds the limit that a collection allows."
        });
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t, "indexTableIsRequired", {
      get: function get() {
        return new t({
          code: Ee.INDEX_TABLE_IS_REQUIRED,
          message: "Index table is required."
        });
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t, "indexTypesNotMatch", {
      get: function get() {
        return new t({
          code: Ee.INDEX_TYPE_NOT_MATCH,
          message: "Indexed column should have primitive type."
        });
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t, "compareTypesNotMatch", {
      get: function get() {
        return new t({
          code: Ee.COMPARE_TYPE_NOT_MATCH,
          message: "Values to compare have different types."
        });
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t, "circularReferenceFound", {
      get: function get() {
        return new t({
          code: Ee.CIRCULAR_REFERENCE_FOUND,
          message: "Cannot handle circular referenced object."
        });
      },
      enumerable: !1,
      configurable: !0
    }), t;
  }(Error);
!function (e) {
  e.INIT = "init", e.READY = "ready", e.CLOSED = "closed";
}(Ce || (Ce = {}));
var Le,
  ke = function ke(e, t) {
    if (void 0 === t && (t = new WeakMap()), "object" == typeof e && null !== e) {
      if (t.has(e)) throw Se.circularReferenceFound;
      t.set(e, !0);
      var n = void 0;
      if (Array.isArray(e)) n = e.map(function (e) {
        return ke(e, t);
      });else if (e instanceof RegExp) n = e;else if (e instanceof Date) n = e;else for (var r in n = {}, e) n[r] = ke(e[r], t);
      return t.delete(e), n;
    }
    return e;
  },
  Re = function Re(e, t) {
    if (null == t) return 1;
    if (null == e) return -1;
    if (typeof e != typeof t) throw Se.compareTypesNotMatch;
    var n = 0;
    switch (typeof e) {
      case "boolean":
      case "number":
        n = e - t;
        break;
      case "string":
        n = e.localeCompare(t);
    }
    return n;
  },
  xe = function xe(e, t) {
    for (var n = 0, r = 0; r < e.length; r++) n = e.charCodeAt(r) + (n << 6) + (n << 16) - n;
    return (n >>> 0) % t;
  },
  De = function De(e) {
    return new Promise(function (t) {
      setTimeout(function () {
        return t();
      }, e);
    });
  },
  Pe = function Pe(e, t) {
    if (!t) return !1;
    if ("function" != typeof e) {
      for (var n in e) {
        if (["/and", "&&"].includes(n)) {
          if (e[n].some(function (e) {
            return !Pe(e, t);
          })) return !1;
        } else if (["/or", "||"].includes(n)) {
          if (e[n].every(function (e) {
            return !Pe(e, t);
          })) return !1;
        } else if ("/where" === n) {
          if (!(0, e[n])(t)) return !1;
        } else {
          var r = n;
          if ("object" == typeof e[r]) {
            var i = e[r];
            for (var s in i) switch (s) {
              case "/eq":
              case "=":
                if ((a = t[r]) !== (o = i[s])) return !1;
                break;
              case "/neq":
              case "!=":
                if ((a = t[r]) === (o = i[s])) return !1;
                break;
              case "/gt":
              case ">":
                var a = t[r],
                  o = i[s];
                if (!(Re(a, o) > 0)) return !1;
                break;
              case "/gte":
              case ">=":
                a = t[r], o = i[s];
                if (!(Re(a, o) >= 0)) return !1;
                break;
              case "/lt":
              case "<":
                a = t[r], o = i[s];
                if (!(Re(a, o) < 0)) return !1;
                break;
              case "/lte":
              case "<=":
                a = t[r], o = i[s];
                if (!(Re(a, o) <= 0)) return !1;
                break;
              case "/in":
                a = t[r];
                if (!(o = i[s]).includes(a)) return !1;
                break;
              case "/nin":
                a = t[r];
                if ((o = i[s]).includes(a)) return !1;
                break;
              case "/contain":
                a = t[r], o = i[s];
                if (!a.includes(o)) return !1;
                break;
              case "/regex":
                a = t[r];
                if (!(o = i[s]).test(a)) return !1;
                break;
              case "/where":
                a = t[r];
                if (!(0, i[s])(a)) return !1;
            }
          } else if ("function" == typeof e[r]) {
            if (!e[r](t[r])) return !1;
          } else if (e[r] !== t[r]) return !1;
        }
      }
      return !0;
    }
    return e(t);
  },
  Me = function Me() {},
  Be = function Be() {
    return Promise.resolve();
  },
  He = function He(e) {
    return e;
  },
  Ue = function Ue(e, t) {
    t();
  };
!function (e) {
  e[e.FORWARD = 0] = "FORWARD", e[e.BACKWARD = 1] = "BACKWARD";
}(Le || (Le = {}));
var Ve,
  Ke,
  qe,
  Fe = function () {
    function e(e) {
      var t = e.initialPrevValue,
        n = void 0 === t ? null : t,
        r = e.initialNextValue,
        i = void 0 === r ? null : r,
        s = e.iterator,
        a = e.map,
        o = void 0 === a ? He : a,
        c = e.backward,
        u = void 0 === c ? Be : c,
        l = e.forward,
        h = void 0 === l ? Be : l,
        d = e.complete,
        f = void 0 === d ? Me : d;
      this._prevValue = n, this._nextValue = i, this._error = null, this._map = o, this._backward = u, this._forward = h, this._iterator = s, this._complete = f;
    }
    return Object.defineProperty(e.prototype, "prevValue", {
      get: function get() {
        return this._map(this._prevValue);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "nextValue", {
      get: function get() {
        return this._map(this._nextValue);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "error", {
      get: function get() {
        return this._error;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "hasPrevious", {
      get: function get() {
        return !!this._prevValue;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "hasNext", {
      get: function get() {
        return !!this._nextValue;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.prev = function () {
      return r(this, void 0, void 0, function () {
        var e, t, n;
        return s(this, function (r) {
          switch (r.label) {
            case 0:
              if (!this.hasPrevious) return [3, 6];
              r.label = 1;
            case 1:
              return r.trys.push([1, 3,, 4]), e = this._prevValue, t = this, [4, this._backward()];
            case 2:
              return t._prevValue = r.sent() || null, this._nextValue = e, [3, 4];
            case 3:
              return n = r.sent(), this._error = n, [3, 4];
            case 4:
              return [4, this._iterator(this)];
            case 5:
              return [2, r.sent()];
            case 6:
              this._complete(), r.label = 7;
            case 7:
              return [2];
          }
        });
      });
    }, e.prototype.next = function () {
      return r(this, void 0, void 0, function () {
        var e, t, n;
        return s(this, function (r) {
          switch (r.label) {
            case 0:
              if (!this.hasNext) return [3, 6];
              r.label = 1;
            case 1:
              return r.trys.push([1, 3,, 4]), e = this._nextValue, t = this, [4, this._forward()];
            case 2:
              return t._nextValue = r.sent() || null, this._prevValue = e, [3, 4];
            case 3:
              return n = r.sent(), this._error = n, [3, 4];
            case 4:
              return [4, this._iterator(this)];
            case 5:
              return [2, r.sent()];
            case 6:
              this._complete(), r.label = 7;
            case 7:
              return [2];
          }
        });
      });
    }, e.prototype.stop = function () {
      this._prevValue = null, this._nextValue = null, this._complete();
    }, e;
  }(),
  je = function () {
    function e(e) {
      var t = e.condition,
        n = void 0 === t ? {} : t,
        r = e.backward,
        i = void 0 !== r && r,
        s = e.blockManager,
        a = e.indexer;
      this.condition = n, this.backward = i, this._blockManager = s, this._indexer = a;
    }
    return e.prototype.findOptimizedStartPosition = function () {
      var e = this,
        t = ["=", "/eq", ">", ">=", "/gt", "/gte"],
        n = ["=", "/eq", "<", "<=", "/lt", "/lte"];
      if (this.backward) {
        var r = this._indexer.origin.length - 1;
        if ("function" != typeof this.condition) for (var i in this._indexer.fields) {
          var s = this._indexer.fields[i],
            a = 1;
          if ("-" === s[0] && (s = s.slice(1), a = -1), this.condition[s]) if ("object" == typeof this.condition[s]) {
            var o = a > 0 ? n : t;
            for (var c in this.condition[s]) if (o.includes(c)) for (var u = r; u >= 0; u--) if (a * Re(this._indexer.origin[u].columnValues[i], this.condition[s][c]) <= 0) {
              r = u;
              break;
            }
          } else for (u = r; u >= 0; u--) if (a * Re(this._indexer.origin[u].columnValues[i], this.condition[s]) <= 0) {
            r = u;
            break;
          }
        }
        return Math.min(r + 1, this._indexer.origin.length - 1);
      }
      var l = 0;
      if ("function" != typeof this.condition) for (var h = function h(r) {
          var i = d._indexer.fields[r],
            s = 1;
          if ("-" === i[0] && (i = i.slice(1), s = -1), d.condition[i]) if ("object" == typeof d.condition[i]) Object.keys(d.condition[i]).forEach(function (a) {
            if ((s > 0 ? t : n).includes(a)) for (var o = l; o < e._indexer.origin.length; o++) if (s * Re(e._indexer.origin[o].columnValues[r], e.condition[i][a]) >= 0) {
              l = o;
              break;
            }
          });else for (var a = l; a < d._indexer.origin.length; a++) if (s * Re(d._indexer.origin[a].columnValues[r], d.condition[i]) >= 0) {
            l = a;
            break;
          }
        }, d = this, i = 0; i < this._indexer.fields.length; i++) h(i);
      return Math.max(l - 1, 0);
    }, e.prototype.each = function (e) {
      return r(this, void 0, void 0, function () {
        var t,
          n,
          i,
          a,
          o,
          c,
          u,
          l = this;
        return s(this, function (h) {
          switch (h.label) {
            case 0:
              if (t = this.findOptimizedStartPosition(), n = 0, this.backward && this._indexer.origin[t] && (n = this._indexer.origin[t].keys.length - 1), i = function i() {
                if (l._indexer.origin[t]) {
                  if (!l._indexer.origin[t].keys[++n]) {
                    if (!l._indexer.origin[++t]) return !1;
                    n = 0;
                  }
                  return !0;
                }
                return !1;
              }, a = function a() {
                if (l._indexer.origin[t]) {
                  if (!l._indexer.origin[t].keys[--n]) {
                    if (!l._indexer.origin[--t]) return !1;
                    n = l._indexer.origin[t].keys.length - 1;
                  }
                  return !0;
                }
                return !1;
              }, o = null, !this._indexer.origin[t]) return [3, 4];
              c = this.backward ? a : i, h.label = 1;
            case 1:
              return [4, this._blockManager.getFromBlock(this._indexer.origin[t].keys[n])];
            case 2:
              if ((u = h.sent()) && Pe(this.condition, u)) return o = u, [3, 4];
              h.label = 3;
            case 3:
              if (c()) return [3, 1];
              h.label = 4;
            case 4:
              return [4, new Promise(function (c) {
                var u = new Fe({
                  initialNextValue: ke(o),
                  iterator: e,
                  forward: function forward() {
                    return r(l, void 0, void 0, function () {
                      var e, r;
                      return s(this, function (s) {
                        switch (s.label) {
                          case 0:
                            e = this.backward ? a : i, s.label = 1;
                          case 1:
                            return e() ? [4, this._blockManager.getFromBlock(this._indexer.origin[t].keys[n])] : [3, 3];
                          case 2:
                            return (r = s.sent()) && Pe(this.condition, r) ? [2, ke(r)] : [3, 1];
                          case 3:
                            return [2, null];
                        }
                      });
                    });
                  },
                  backward: function backward() {
                    return r(l, void 0, void 0, function () {
                      var e, r;
                      return s(this, function (s) {
                        switch (s.label) {
                          case 0:
                            e = this.backward ? i : a, s.label = 1;
                          case 1:
                            return e() ? [4, this._blockManager.getFromBlock(this._indexer.origin[t].keys[n])] : [3, 3];
                          case 2:
                            return (r = s.sent()) && Pe(this.condition, r) ? [2, ke(r)] : [3, 1];
                          case 3:
                            return [2, null];
                        }
                      });
                    });
                  },
                  complete: c
                });
                e(u);
              })];
            case 5:
              return [2, h.sent()];
          }
        });
      });
    }, e;
  }(),
  Ge = function () {
    function e(e) {
      var t = e.condition,
        n = void 0 === t ? {} : t,
        r = e.backward,
        i = void 0 !== r && r,
        s = e.mutex,
        a = e.blockManager,
        o = e.indexer;
      this._mutex = s, this._iterator = new je({
        condition: n,
        backward: i,
        blockManager: a,
        indexer: o
      });
    }
    return e.prototype.fetch = function (e) {
      return void 0 === e && (e = {}), r(this, void 0, void 0, function () {
        var t,
          n,
          i,
          a,
          o = this;
        return s(this, function (c) {
          switch (c.label) {
            case 0:
              if (t = Math.max(e.offset || 0, 0), 0 === (n = "number" == typeof e.limit ? e.limit : Number.MAX_SAFE_INTEGER)) return [2, []];
              if (n < 0) throw Se.collectionQueryNotValid;
              c.label = 1;
            case 1:
              return c.trys.push([1, 4,, 5]), i = [], [4, this._mutex.lock()];
            case 2:
              return c.sent(), [4, this._iterator.each(function (e) {
                return r(o, void 0, void 0, function () {
                  return s(this, function (r) {
                    return e.error ? e.stop() : e.hasNext ? 0 === t ? (i.push(e.nextValue), 0 < n && n <= i.length ? e.stop() : e.next()) : (t--, e.next()) : e.stop(), [2];
                  });
                });
              })];
            case 3:
              return c.sent(), this._mutex.unlock(), [2, i];
            case 4:
              throw a = c.sent(), this._mutex.unlock(), a;
            case 5:
              return [2];
          }
        });
      });
    }, e.prototype.count = function () {
      return r(this, void 0, void 0, function () {
        var e,
          t,
          n = this;
        return s(this, function (i) {
          switch (i.label) {
            case 0:
              return i.trys.push([0, 3,, 4]), e = 0, [4, this._mutex.lock()];
            case 1:
              return i.sent(), [4, this._iterator.each(function (t) {
                return r(n, void 0, void 0, function () {
                  return s(this, function (n) {
                    return t.error ? t.stop() : t.hasNext ? (e++, t.next()) : t.stop(), [2];
                  });
                });
              })];
            case 2:
              return i.sent(), this._mutex.unlock(), [2, e];
            case 3:
              throw t = i.sent(), this._mutex.unlock(), t;
            case 4:
              return [2];
          }
        });
      });
    }, e;
  }(),
  ze = function ze(e) {
    return "".concat("nest", "@").concat(e);
  },
  We = function We(e, t) {
    return "".concat(ze(e), "/").concat(t);
  },
  Ye = function Ye(e, t) {
    return "".concat(We(e, t), ".metadata");
  },
  Qe = function Qe(e, t) {
    return "".concat(We(e, t), "/block.");
  },
  Je = function Je(e, t) {
    return "".concat(We(e, t), "/blob.");
  },
  Ze = function () {
    function e(e) {
      var t = e.dbname,
        n = e.collectionName,
        r = e.store;
      this.dbname = t, this.collectionName = n, this.store = r;
    }
    return e.prototype.get = function (e) {
      return r(this, void 0, void 0, function () {
        var t, n, r, i, a, o, c, u, l;
        return s(this, function (s) {
          switch (s.label) {
            case 0:
              return [4, this.store.get(e)];
            case 1:
              return (t = s.sent()) ? (n = t.data, r = t.type, "undefined" == typeof fetch ? [3, 4] : [4, fetch(n)]) : [3, 5];
            case 2:
              return [4, s.sent().blob()];
            case 3:
              return [2, s.sent()];
            case 4:
              for (512, i = [], a = atob(n.split(",")[1]), o = 0; o < a.length; o += 512) {
                for (c = a.slice(o, o + 512), u = new Array(c.length), l = 0; l < c.length; l++) u[l] = c.charCodeAt(l);
                i.push(new Uint8Array(u));
              }
              return [2, new Blob(i, {
                type: r
              })];
            case 5:
              return [2, null];
          }
        });
      });
    }, e.prototype.save = function (e, t) {
      return void 0 === t && (t = "".concat(Date.now())), r(this, void 0, void 0, function () {
        var n,
          r,
          i,
          a,
          o = this;
        return s(this, function (s) {
          switch (s.label) {
            case 0:
              return [4, new Promise(function (n) {
                var r = function (e, t, n, r) {
                    return void 0 === r && (r = 0), "".concat(Je(e, t)).concat(n, ".").concat(r);
                  }(o.dbname, o.collectionName, t),
                  i = new FileReader();
                i.onload = function () {
                  n({
                    blobId: r,
                    data: i.result,
                    type: e.type
                  });
                }, i.readAsDataURL(e);
              })];
            case 1:
              return n = s.sent(), r = n.blobId, i = n.data, a = n.type, [4, this.store.set({
                key: r,
                value: {
                  data: i,
                  type: a
                }
              })];
            case 2:
              return s.sent(), [2, r];
          }
        });
      });
    }, e.prototype.remove = function (e) {
      return r(this, void 0, void 0, function () {
        return s(this, function (t) {
          switch (t.label) {
            case 0:
              return [4, this.store.remove(e)];
            case 1:
              return t.sent(), [2];
          }
        });
      });
    }, e.prototype.clear = function () {
      return r(this, void 0, void 0, function () {
        var e,
          t,
          n = this;
        return s(this, function (i) {
          switch (i.label) {
            case 0:
              return e = Je(this.dbname, this.collectionName), [4, this.store.getAllKeys()];
            case 1:
              return t = i.sent(), [4, Promise.all(t.filter(function (t) {
                return t.startsWith(e);
              }).map(function (e) {
                return r(n, void 0, void 0, function () {
                  return s(this, function (t) {
                    switch (t.label) {
                      case 0:
                        return [4, this.store.remove(e)];
                      case 1:
                        return [2, t.sent()];
                    }
                  });
                });
              }))];
            case 2:
              return i.sent(), [2];
          }
        });
      });
    }, e;
  }();
!function (e) {
  e[e.COMMIT = 0] = "COMMIT", e[e.WRITE = 1] = "WRITE", e[e.ERROR = 2] = "ERROR";
}(Ve || (Ve = {})), function (e) {
  e.PENDING = "pending", e.PERSISTENT = "persistent", e.VOLATILE = "volatile";
}(Ke || (Ke = {})), function (e) {
  e[e.NO_CACHE = 0] = "NO_CACHE", e[e.DEFAULT = 1] = "DEFAULT", e[e.PERSISTENT = 2] = "PERSISTENT";
}(qe || (qe = {}));
var Xe,
  $e = [Ke.PENDING, Ke.VOLATILE],
  et = {},
  tt = function () {
    function e(e) {
      var t = e.dbname,
        n = e.limit,
        r = void 0 === n ? 256 : n;
      return et[t] || (this.dbname = t, this._items = [], this._limit = r, et[t] = this), et[t];
    }
    return e.get = function (e) {
      return et[e];
    }, Object.defineProperty(e.prototype, "items", {
      get: function get() {
        return this._items;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.find = function (e, t, n) {
      return void 0 === n && (n = qe.DEFAULT), r(this, void 0, void 0, function () {
        var r, i;
        return s(this, function (s) {
          switch (s.label) {
            case 0:
              return (r = this.get(t)) ? [3, 2] : [4, e.get(t)];
            case 1:
              return (i = s.sent()) && (r = {
                key: t,
                value: i,
                state: n === qe.PERSISTENT ? Ke.PERSISTENT : Ke.VOLATILE
              }, this.put(r)), [3, 3];
            case 2:
              n === qe.PERSISTENT && (r.state = Ke.PERSISTENT), s.label = 3;
            case 3:
              return [2, r];
          }
        });
      });
    }, e.prototype.get = function (e, t) {
      void 0 === t && (t = qe.DEFAULT);
      var n = this._items.map(function (e) {
        return e.key;
      }).indexOf(e);
      if (n > -1) {
        var r = this._items[n];
        return t === qe.PERSISTENT && (r.state = Ke.PERSISTENT), t !== qe.NO_CACHE && this.put(r), r;
      }
      return null;
    }, e.prototype.put = function (e) {
      var t, n;
      if (this._limit > 0) {
        var r = this._items.map(function (e) {
          return e.key;
        }).indexOf(e.key);
        if (r > -1) $e.includes(this._items[r].state) && $e.includes(e.state) ? (this._items.splice(r, 1), this._items.push(e)) : (this._items[r].state = e.state, this._items[r].value = e.value);else {
          this._items.push(e);
          var s = this._items.filter(function (e) {
              return e.state === Ke.VOLATILE;
            }),
            a = s.length - this._limit;
          if (a > 0) {
            var o = [];
            try {
              for (var c = i(this._items), u = c.next(); !u.done; u = c.next()) {
                var l = u.value;
                l.state === Ke.VOLATILE && a > 0 ? a-- : o.push(l);
              }
            } catch (e) {
              t = {
                error: e
              };
            } finally {
              try {
                u && !u.done && (n = c.return) && n.call(c);
              } finally {
                if (t) throw t.error;
              }
            }
            this._items = o;
          }
        }
      }
    }, e.prototype.remove = function (e) {
      var t = this._items.map(function (e) {
        return e.key;
      }).indexOf(e);
      t > -1 && this._items.splice(t, 1);
    }, e.prototype.clearByCondition = function (e) {
      this._items = this._items.filter(function (t) {
        return !e(t);
      });
    }, e.prototype.clear = function (e) {
      void 0 === e && (e = !1), this._items = e ? [] : this._items.filter(function (e) {
        return e.state !== Ke.VOLATILE;
      });
    }, e;
  }(),
  nt = function () {
    function e(e) {
      var t = e.dbname,
        n = e.collectionName,
        r = e.store;
      this._requests = [], this._onCommit = new Map(), this._onWrite = new Map(), this._onError = new Map(), this.dbname = t, this.collectionName = n, this.metadataKey = function (e, t) {
        return "".concat(We(e, t), "/trans.metadata");
      }(t, n), this.recordsetKey = function (e, t) {
        return "".concat(We(e, t), "/trans.recordset");
      }(t, n), this._store = r;
    }
    return Object.defineProperty(e.prototype, "generation", {
      get: function get() {
        return this._metadata ? this._metadata.generation : 0;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "requestCount", {
      get: function get() {
        return this._requests.length;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype._getReducedRecordset = function (e) {
      return void 0 === e && (e = []), r(this, void 0, void 0, function () {
        var t;
        return s(this, function (n) {
          switch (n.label) {
            case 0:
              return [4, this._store.get(this.recordsetKey)];
            case 1:
              return (t = n.sent() || []).push.apply(t, I([], w(e), !1)), [2, this._reduceRecordSet(t)];
          }
        });
      });
    }, e.prototype._reduceRecordSet = function (e) {
      for (var t = [], n = {}, r = e.length - 1; r >= 0; r--) {
        for (var i = e[r], s = [], a = i.requests.length - 1; a >= 0; a--) {
          var o = i.requests[a],
            c = o.data;
          n[c.key] || (s.unshift(o), n[c.key] = !0);
        }
        s.length > 0 && (i.requests = s, t.unshift(i));
      }
      return t;
    }, e.prototype._applyRecord = function (e, t) {
      return r(this, void 0, void 0, function () {
        var n, r, i, o, c, u, l, h, d;
        return s(this, function (s) {
          switch (s.label) {
            case 0:
              n = tt.get(this.dbname), r = t.generation, i = t.requests, o = null, s.label = 1;
            case 1:
              return s.trys.push([1, 3,, 4]), [4, this._store.setMany(i.map(function (e) {
                return a(a({}, e.data), {
                  generation: r
                });
              }))];
            case 2:
              for (c = s.sent(), u = 0; u < i.length; u++) c[u] instanceof Error && (o || (o = c[u]), l = i[u].data, n.put(a(a({}, l), {
                state: Ke.PERSISTENT
              })));
              return [3, 4];
            case 3:
              return h = s.sent(), o = h, [3, 4];
            case 4:
              return o ? [3, 6] : (d = e.filter(function (e) {
                return e.generation !== r;
              }), [4, this._store.set({
                key: this.recordsetKey,
                value: d
              })]);
            case 5:
              return s.sent(), this._onWrite.forEach(function (e) {
                e(i.map(function (e) {
                  return e.data;
                }));
              }), [3, 7];
            case 6:
              this._onError.forEach(function (e) {
                o && e(o);
              }), s.label = 7;
            case 7:
              return [2];
          }
        });
      });
    }, e.prototype.init = function () {
      return r(this, void 0, void 0, function () {
        var e, t, n, r, a, o, c, u;
        return s(this, function (s) {
          switch (s.label) {
            case 0:
              return e = this, [4, this._store.get(this.metadataKey)];
            case 1:
              return e._metadata = s.sent() || {
                generation: 1
              }, [4, this._getReducedRecordset()];
            case 2:
              t = s.sent(), s.label = 3;
            case 3:
              s.trys.push([3, 8, 9, 10]), n = i(t), r = n.next(), s.label = 4;
            case 4:
              return r.done ? [3, 7] : (a = r.value, [4, this._applyRecord(t, a)]);
            case 5:
              s.sent(), s.label = 6;
            case 6:
              return r = n.next(), [3, 4];
            case 7:
              return [3, 10];
            case 8:
              return o = s.sent(), c = {
                error: o
              }, [3, 10];
            case 9:
              try {
                r && !r.done && (u = n.return) && u.call(n);
              } finally {
                if (c) throw c.error;
              }
              return [7];
            case 10:
              return [2];
          }
        });
      });
    }, e.prototype.on = function (e, t, n) {
      switch (e) {
        case Ve.COMMIT:
          this._onCommit.set(t, n);
          break;
        case Ve.WRITE:
          this._onWrite.set(t, n);
          break;
        case Ve.ERROR:
          this._onError.set(t, n);
      }
    }, e.prototype.requestWrite = function (e, t) {
      this._requests.push({
        data: e,
        options: t
      }), tt.get(this.dbname).put(a({
        state: Ke.PENDING
      }, e));
    }, e.prototype.requestMultipleWrite = function (e, t) {
      var n,
        r,
        s = tt.get(this.dbname);
      try {
        for (var o = i(e), c = o.next(); !c.done; c = o.next()) {
          var u = c.value;
          this._requests.push({
            data: u,
            options: t
          }), s.put(a({
            state: Ke.PENDING
          }, u));
        }
      } catch (e) {
        n = {
          error: e
        };
      } finally {
        try {
          c && !c.done && (r = o.return) && r.call(o);
        } finally {
          if (n) throw n.error;
        }
      }
    }, e.prototype.clear = function () {
      return r(this, void 0, void 0, function () {
        return s(this, function (e) {
          return tt.get(this.dbname).clearByCondition(function (e) {
            return e.state === Ke.PENDING;
          }), this._requests = [], [2];
        });
      });
    }, e.prototype.commit = function () {
      return r(this, void 0, void 0, function () {
        var e,
          t,
          n,
          r,
          i,
          o,
          c,
          u,
          l,
          h,
          d,
          f,
          _ = this;
        return s(this, function (s) {
          switch (s.label) {
            case 0:
              if (!((e = this._requests).length > 0)) return [3, 4];
              for (t = [], n = {}, u = e.length - 1; u >= 0; u--) r = e[u], h = r.data, n[h.key] || (n[h.key] = !0, t.unshift(r));
              return i = {
                generation: this.generation,
                requests: t
              }, [4, this._getReducedRecordset([i])];
            case 1:
              return o = s.sent(), [4, this._store.set({
                key: this.recordsetKey,
                value: o
              })];
            case 2:
              return s.sent(), this._metadata.generation++, [4, this._store.set({
                key: this.metadataKey,
                value: this._metadata
              })];
            case 3:
              for (s.sent(), c = tt.get(this.dbname), u = 0; u < t.length; u++) l = t[u], h = l.data, d = l.options, c.put(a(a({}, h), {
                state: d && d.persistent ? Ke.PERSISTENT : Ke.VOLATILE
              }));
              this._requests = [], this._onCommit.forEach(function (t) {
                t(e.map(function (e) {
                  return e.data;
                }));
              }), f = Oe.get(this.dbname), setTimeout(function () {
                try {
                  _._applyRecord(o, i);
                } catch (e) {
                  _._onError.forEach(function (t) {
                    return t(e);
                  });
                }
              }, f.transactionApplyDelay), s.label = 4;
            case 4:
              return [2];
          }
        });
      });
    }, e;
  }(),
  rt = function () {
    function e(e) {
      var t = e.blockId,
        n = e.keyName,
        r = e.items,
        i = void 0 === r ? [] : r,
        s = e.limit;
      this.blockId = t, this.keyName = n, this.limit = s, this._items = I([], w(i), !1);
    }
    return e.createFromCacheItem = function (t) {
      return t ? new e(t.value) : null;
    }, Object.defineProperty(e.prototype, "isEmpty", {
      get: function get() {
        return 0 === this._items.length;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "items", {
      get: function get() {
        return this._items;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.serialize = function () {
      return {
        blockId: this.blockId,
        keyName: this.keyName,
        limit: this.limit,
        items: this._items
      };
    }, e.prototype.getItemByKey = function (e) {
      var t = this,
        n = this._items.find(function (n) {
          var r = n[t.keyName];
          return e === r;
        });
      return null != n ? n : null;
    }, e.prototype.has = function (e) {
      var t = this;
      return this._items.map(function (e) {
        return e[t.keyName];
      }).includes(e);
    }, e.prototype.add = function (e) {
      var t = this,
        n = this._items.map(function (e) {
          return e[t.keyName];
        }).indexOf(e[this.keyName]);
      return n < 0 ? this._items.length < this.limit && (this._items.push(e), !0) : (this._items[n] = e, !0);
    }, e.prototype.remove = function (e) {
      for (var t in this._items) if (this._items[t][this.keyName] === e) return this._items.splice(parseInt(t), 1), !0;
      return !1;
    }, e.prototype.clear = function () {
      this._items = [];
    }, e;
  }(),
  it = function () {
    function e(e) {
      var t = e.dbname,
        n = e.collectionName,
        r = e.metadata,
        i = e.hashFunction,
        s = void 0 === i ? xe : i,
        a = e.transaction,
        o = e.store;
      this.dbname = t, this.collectionName = n, this.hashFunction = s, this.metadata = r, this._transaction = a, this._store = o;
    }
    return Object.defineProperty(e.prototype, "keyName", {
      get: function get() {
        return this.metadata.keyName;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.createBlockId = function (e, t) {
      return void 0 === t && (t = this.metadata.blockLevel), n = this.dbname, r = this.collectionName, i = t, s = "".concat(function (e, t, n) {
        var r = n.base * Math.pow(n.multiplier, t) + n.constant;
        return (n.hashFunction || xe)(e, r);
      }(e, t, {
        hashFunction: this.hashFunction,
        base: this.metadata.blockHashBase,
        multiplier: this.metadata.blockHashMultiplier,
        constant: this.metadata.blockHashConstant
      })), "".concat(Qe(n, r)).concat(i, ".").concat(s);
      var n, r, i, s;
    }, e.prototype._findBlock = function (e) {
      return r(this, void 0, void 0, function () {
        var t, n, r, i, a;
        return s(this, function (s) {
          switch (s.label) {
            case 0:
              t = tt.get(this.dbname), n = this.metadata.blockLevel, s.label = 1;
            case 1:
              return n > 0 ? (r = this.createBlockId(e, n), [4, t.find(this._store, r)]) : [3, 4];
            case 2:
              if ((i = s.sent()) && (a = rt.createFromCacheItem(i), null == a ? void 0 : a.getItemByKey(e))) return [2, a];
              s.label = 3;
            case 3:
              return n--, [3, 1];
            case 4:
              return [2, null];
          }
        });
      });
    }, e.prototype.getFromBlock = function (e) {
      return r(this, void 0, void 0, function () {
        var t;
        return s(this, function (n) {
          switch (n.label) {
            case 0:
              return [4, this._findBlock(e)];
            case 1:
              return [2, (t = n.sent()) ? t.getItemByKey(e) : null];
          }
        });
      });
    }, e.prototype.putToBlock = function (e, t) {
      return r(this, void 0, void 0, function () {
        var n, r, i, a, o;
        return s(this, function (s) {
          switch (s.label) {
            case 0:
              return n = Oe.get(this.dbname), r = this.createBlockId(e), i = Math.floor(this._store.itemSizeLimit / n.itemSizeLimit), [4, tt.get(this.dbname).find(this._store, r)];
            case 1:
              return a = s.sent(), (null == (o = a ? rt.createFromCacheItem(a) : new rt({
                blockId: r,
                keyName: this.keyName,
                items: [],
                limit: i
              })) ? void 0 : o.add(t)) ? (this._transaction.requestWrite({
                key: o.blockId,
                value: o.serialize()
              }), [2, !0]) : [2, !1];
          }
        });
      });
    }, e.prototype.removeFromBlock = function (e) {
      return r(this, void 0, void 0, function () {
        var t;
        return s(this, function (n) {
          switch (n.label) {
            case 0:
              return [4, this._findBlock(e)];
            case 1:
              return (t = n.sent()) && t.remove(e) ? (this._transaction.requestWrite({
                key: t.blockId,
                value: t.serialize()
              }), [2, !0]) : [2, !1];
          }
        });
      });
    }, e.prototype.clearAllBlocks = function () {
      return r(this, void 0, void 0, function () {
        var e, t, n;
        return s(this, function (r) {
          switch (r.label) {
            case 0:
              return e = Qe(this.dbname, this.collectionName), [4, this._store.getAllKeys()];
            case 1:
              return t = r.sent(), n = t.filter(function (t) {
                return t.startsWith(e);
              }), [4, this._store.removeMany(n)];
            case 2:
              return r.sent(), [4, this._transaction.clear()];
            case 3:
              return r.sent(), tt.get(this.dbname).clearByCondition(function (t) {
                return t.key.startsWith(e);
              }), [2];
          }
        });
      });
    }, e;
  }(),
  st = {},
  at = function () {
    function e(e) {
      var t = e.dbname,
        n = e.collectionName,
        r = e.keyName,
        i = e.fields,
        s = e.transaction,
        a = e.store,
        o = this;
      this._origin = [], this._table = [];
      var c = function (e, t, n) {
        return "".concat(We(e, t), "/index.").concat(n);
      }(t, n, i.join(">"));
      return st[c] || (this.dbname = t, this.collectionName = n, this.keyName = r, this.fields = i, this.indexerKey = c, this._transaction = s, this._store = a, this._transaction.on(Ve.COMMIT, this.indexerKey, function () {
        return o.commit();
      }), this._transaction.on(Ve.ERROR, this.indexerKey, function () {
        return o.abort();
      })), st[c];
    }
    return e.createKey = function (e) {
      return e.join(">");
    }, e.parseKey = function (e) {
      return e.split(">");
    }, e.clearIndexerMap = function () {
      for (var e in st) delete st[e];
    }, e.prototype._addItem = function (e) {
      var t = e[this.keyName],
        n = this.getColumnValues(e),
        r = w(this.indexOf(n), 2),
        i = r[0];
      return r[1] ? !this._table[i].keys.includes(t) && (this._table[i].keys.push(t), !0) : (this._table.splice(i, 0, {
        columnValues: n,
        keys: [t]
      }), !0);
    }, e.prototype._removeItem = function (e) {
      var t = e[this.keyName],
        n = this.getColumnValues(e),
        r = w(this.indexOf(n), 2),
        i = r[0];
      if (r[1]) {
        var s = this._table[i].keys.indexOf(t);
        if (s > -1) return this._table[i].keys.splice(s, 1), 0 === this._table[i].keys.length && this._table.splice(i, 1), !0;
      }
      return !1;
    }, Object.defineProperty(e.prototype, "origin", {
      get: function get() {
        return this._origin;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "table", {
      get: function get() {
        return this._table;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.getColumnValues = function (e) {
      var t,
        n,
        r,
        s,
        a = [];
      try {
        for (var o = i(this.fields), c = o.next(); !c.done; c = o.next()) {
          var u = c.value;
          if ("-" === u[0] && (u = u.slice(1)), r = e[u], s = void 0, s = typeof r, null !== r && "undefined" !== s && "boolean" !== s && "number" !== s && "string" !== s) throw Se.indexTypesNotMatch;
          a.push(e[u]);
        }
      } catch (e) {
        t = {
          error: e
        };
      } finally {
        try {
          c && !c.done && (n = o.return) && n.call(o);
        } finally {
          if (t) throw t.error;
        }
      }
      return a;
    }, e.prototype.diff = function (e, t) {
      for (var n in this.fields) {
        var r = "-" === this.fields[n][0] ? -1 : 1,
          i = Re(e[n], t[n]);
        if (0 !== i) return r * i;
      }
      return 0;
    }, e.prototype.indexOf = function (e) {
      if (this._table.length > 0) {
        for (var t = 0, n = this._table.length - 1; t <= n;) {
          var r = Math.floor((t + n) / 2),
            i = this.diff(e, this._table[r].columnValues);
          if (i > 0) t = r + 1;else {
            if (!(i < 0)) return [r, !0];
            n = r - 1;
          }
        }
        return [t, !1];
      }
      return [0, !1];
    }, e.prototype.ensure = function () {
      return r(this, void 0, void 0, function () {
        var e, t, n, r, a, o, c, u, l, h, d, f, _, v, p, m, y;
        return s(this, function (s) {
          switch (s.label) {
            case 0:
              return [4, (e = tt.get(this.dbname)).find(this._store, this.indexerKey, qe.PERSISTENT)];
            case 1:
              return (t = s.sent()) ? [3, 11] : (n = Qe(this.dbname, this.collectionName), [4, this._store.getAllKeys()]);
            case 2:
              r = s.sent(), s.label = 3;
            case 3:
              s.trys.push([3, 8, 9, 10]), a = i(r), o = a.next(), s.label = 4;
            case 4:
              return o.done ? [3, 7] : (c = o.value).startsWith(n) ? [4, e.find(this._store, c, qe.NO_CACHE)] : [3, 6];
            case 5:
              if (u = s.sent(), l = rt.createFromCacheItem(u)) try {
                for (m = void 0, h = i(l.items), d = h.next(); !d.done; d = h.next()) f = d.value, this._addItem(f);
              } catch (e) {
                m = {
                  error: e
                };
              } finally {
                try {
                  d && !d.done && (y = h.return) && y.call(h);
                } finally {
                  if (m) throw m.error;
                }
              }
              s.label = 6;
            case 6:
              return o = a.next(), [3, 4];
            case 7:
              return [3, 10];
            case 8:
              return _ = s.sent(), v = {
                error: _
              }, [3, 10];
            case 9:
              try {
                o && !o.done && (p = a.return) && p.call(a);
              } finally {
                if (v) throw v.error;
              }
              return [7];
            case 10:
              return this._transaction.requestWrite({
                key: this.indexerKey,
                value: this._table
              }, {
                persistent: !0
              }), [3, 12];
            case 11:
              this._origin = t.value, this._table = ke(this._origin), s.label = 12;
            case 12:
              return st[this.indexerKey] = this, [2];
          }
        });
      });
    }, e.prototype.drop = function () {
      return r(this, void 0, void 0, function () {
        return s(this, function (e) {
          switch (e.label) {
            case 0:
              return tt.get(this.dbname).remove(this.indexerKey), [4, this._store.remove(this.indexerKey)];
            case 1:
              return e.sent(), delete st[this.indexerKey], [2];
          }
        });
      });
    }, e.prototype.addItem = function (e) {
      return r(this, void 0, void 0, function () {
        return s(this, function (t) {
          return this._addItem(e) && this._transaction.requestWrite({
            key: this.indexerKey,
            value: this._table
          }, {
            persistent: !0
          }), [2];
        });
      });
    }, e.prototype.removeItem = function (e) {
      return r(this, void 0, void 0, function () {
        return s(this, function (t) {
          return this._removeItem(e) && this._transaction.requestWrite({
            key: this.indexerKey,
            value: this._table
          }, {
            persistent: !0
          }), [2];
        });
      });
    }, e.prototype.clear = function () {
      return r(this, void 0, void 0, function () {
        return s(this, function (e) {
          return this._table = [], this._transaction.requestWrite({
            key: this.indexerKey,
            value: this._table
          }, {
            persistent: !0
          }), [2];
        });
      });
    }, e.prototype.commit = function () {
      this._origin = this._table, this._table = ke(this._origin);
    }, e.prototype.abort = function () {
      this._table = ke(this._origin);
    }, e;
  }(),
  ot = function () {
    function e(e) {
      var t = e.dbname,
        n = e.collectionName,
        r = e.keyName,
        i = e.keyHash,
        s = e.indexes,
        a = e.store,
        o = this;
      this._state = Ce.INIT, this._indexers = [], this.dbname = t, this.name = n, this.keyName = r, this.indexes = I([[r]], w(s.filter(function (e) {
        return at.createKey(e) !== o.keyName;
      })), !1), this._keyHash = i, this._store = a, this._mutex = new re(function (e, t) {
        return "".concat(We(e, t), ".lock");
      }(t, n)), this._blobContainer = new Ze({
        dbname: t,
        collectionName: n,
        store: a
      }), this._transaction = new nt({
        dbname: t,
        collectionName: n,
        store: a
      });
    }
    return e.metadataOf = function (e, t, n) {
      return r(this, void 0, void 0, function () {
        var r;
        return s(this, function (i) {
          switch (i.label) {
            case 0:
              return r = Ye(e, t), [4, n.get(r)];
            case 1:
              return [2, i.sent()];
          }
        });
      });
    }, Object.defineProperty(e.prototype, "state", {
      get: function get() {
        return this._state;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "isReady", {
      get: function get() {
        return this._state === Ce.READY;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.init = function () {
      return r(this, void 0, void 0, function () {
        var t,
          n,
          r,
          a,
          o,
          c,
          u,
          l,
          h,
          d,
          f,
          _,
          v,
          p,
          m = this;
        return s(this, function (s) {
          switch (s.label) {
            case 0:
              return [4, this._mutex.lock()];
            case 1:
              s.sent(), s.label = 2;
            case 2:
              return s.trys.push([2, 9,, 10]), t = Oe.get(this.dbname), [4, e.metadataOf(this.dbname, this.name, this._store)];
            case 3:
              return n = s.sent(), this._metadata = n || {
                keyName: this.keyName,
                blockLevel: 1,
                blockHashBase: t.blockHashBase,
                blockHashMultiplier: t.blockHashMultiplier,
                blockHashConstant: t.blockHashConstant,
                indexes: this.indexes
              }, [4, this._transaction.init()];
            case 4:
              s.sent(), this._blockManager = new it({
                dbname: this.dbname,
                collectionName: this.name,
                hashFunction: this._keyHash,
                metadata: this._metadata,
                transaction: this._transaction,
                store: this._store
              }), r = I([], w(this.indexes), !1), a = [], o = r.map(function (e) {
                return at.createKey(e);
              }), c = n ? n.indexes.map(function (e) {
                return at.createKey(e);
              }) : [];
              try {
                for (u = i(c), l = u.next(); !l.done; l = u.next()) h = l.value, o.includes(h) || a.push(at.parseKey(h));
              } catch (e) {
                v = {
                  error: e
                };
              } finally {
                try {
                  l && !l.done && (p = u.return) && p.call(u);
                } finally {
                  if (v) throw v.error;
                }
              }
              return (d = []).push.apply(d, I([], w(r.map(function (e) {
                var t = new at({
                  dbname: m.dbname,
                  collectionName: m.name,
                  keyName: m.keyName,
                  fields: e,
                  transaction: m._transaction,
                  store: m._store
                });
                return m._indexers.push(t), t.ensure();
              })), !1)), d.push.apply(d, I([], w(a.map(function (e) {
                return new at({
                  dbname: m.dbname,
                  collectionName: m.name,
                  keyName: m.keyName,
                  fields: e,
                  transaction: m._transaction,
                  store: m._store
                }).drop();
              })), !1)), [4, Promise.all(d)];
            case 5:
              return s.sent(), [4, this._transaction.commit()];
            case 6:
              return s.sent(), o.sort().join(",") === c.sort().join(",") ? [3, 8] : (f = Ye(this.dbname, this.name), this._metadata.indexes = r, [4, this._store.set({
                key: f,
                value: this._metadata
              })]);
            case 7:
              s.sent(), s.label = 8;
            case 8:
              return this._state = Ce.READY, this._mutex.unlock(), [3, 10];
            case 9:
              throw _ = s.sent(), this._mutex.unlock(), _;
            case 10:
              return [2];
          }
        });
      });
    }, e.prototype.close = function () {
      this._state = Ce.CLOSED;
    }, e.prototype._hasPropertyOfKeyName = function (e) {
      var t = e[this.keyName];
      return "string" == typeof t && !!t;
    }, e.prototype._getIndexerBy = function (e) {
      var t, n;
      void 0 === e && (e = null), e || (e = [this.keyName]);
      var r = at.createKey(e);
      try {
        for (var s = i(this._indexers), a = s.next(); !a.done; a = s.next()) {
          var o = a.value;
          if (r === at.createKey(o.fields)) return o;
        }
      } catch (e) {
        t = {
          error: e
        };
      } finally {
        try {
          a && !a.done && (n = s.return) && n.call(s);
        } finally {
          if (t) throw t.error;
        }
      }
      throw Se.indexTableIsRequired;
    }, e.prototype._upgradeBlockLevel = function () {
      return r(this, void 0, void 0, function () {
        var e;
        return s(this, function (t) {
          switch (t.label) {
            case 0:
              return e = Ye(this.dbname, this.name), this._metadata.blockLevel++, [4, this._store.set({
                key: e,
                value: this._metadata
              })];
            case 1:
              return t.sent(), [2];
          }
        });
      });
    }, e.prototype._requestInsert = function (e) {
      return r(this, void 0, void 0, function () {
        var t, n, r, a, o, c;
        return s(this, function (s) {
          switch (s.label) {
            case 0:
              return t = e[this.keyName], [4, this._blockManager.getFromBlock(t)];
            case 1:
              return s.sent() ? [3, 13] : [4, this._blockManager.putToBlock(t, e)];
            case 2:
              return s.sent() ? [3, 5] : [4, this._upgradeBlockLevel()];
            case 3:
              return s.sent(), [4, this._blockManager.putToBlock(t, e)];
            case 4:
              s.sent(), s.label = 5;
            case 5:
              s.trys.push([5, 10, 11, 12]), n = i(this._indexers), r = n.next(), s.label = 6;
            case 6:
              return r.done ? [3, 9] : [4, r.value.addItem(e)];
            case 7:
              s.sent(), s.label = 8;
            case 8:
              return r = n.next(), [3, 6];
            case 9:
              return [3, 12];
            case 10:
              return a = s.sent(), o = {
                error: a
              }, [3, 12];
            case 11:
              try {
                r && !r.done && (c = n.return) && c.call(n);
              } finally {
                if (o) throw o.error;
              }
              return [7];
            case 12:
              return [3, 14];
            case 13:
              throw Se.collectionInsertDuplicate;
            case 14:
              return [2];
          }
        });
      });
    }, e.prototype._requestUpsert = function (e) {
      return r(this, void 0, void 0, function () {
        var t, n, r, a, o, c, u, l, h, d, f, _, v;
        return s(this, function (s) {
          switch (s.label) {
            case 0:
              return t = e[this.keyName], [4, this._blockManager.getFromBlock(t)];
            case 1:
              return (n = s.sent()) ? [3, 13] : [4, this._blockManager.putToBlock(t, e)];
            case 2:
              return s.sent() ? [3, 5] : [4, this._upgradeBlockLevel()];
            case 3:
              return s.sent(), [4, this._blockManager.putToBlock(t, e)];
            case 4:
              s.sent(), s.label = 5;
            case 5:
              s.trys.push([5, 10, 11, 12]), r = i(this._indexers), a = r.next(), s.label = 6;
            case 6:
              return a.done ? [3, 9] : [4, (l = a.value).addItem(e)];
            case 7:
              s.sent(), s.label = 8;
            case 8:
              return a = r.next(), [3, 6];
            case 9:
              return [3, 12];
            case 10:
              return o = s.sent(), d = {
                error: o
              }, [3, 12];
            case 11:
              try {
                a && !a.done && (f = r.return) && f.call(r);
              } finally {
                if (d) throw d.error;
              }
              return [7];
            case 12:
              return [3, 23];
            case 13:
              return [4, this._blockManager.putToBlock(t, e)];
            case 14:
              s.sent(), s.label = 15;
            case 15:
              s.trys.push([15, 21, 22, 23]), c = i(this._indexers), u = c.next(), s.label = 16;
            case 16:
              return u.done ? [3, 20] : 0 === (l = u.value).diff(l.getColumnValues(n), l.getColumnValues(e)) ? [3, 19] : [4, l.removeItem(n)];
            case 17:
              return s.sent(), [4, l.addItem(e)];
            case 18:
              s.sent(), s.label = 19;
            case 19:
              return u = c.next(), [3, 16];
            case 20:
              return [3, 23];
            case 21:
              return h = s.sent(), _ = {
                error: h
              }, [3, 23];
            case 22:
              try {
                u && !u.done && (v = c.return) && v.call(c);
              } finally {
                if (_) throw _.error;
              }
              return [7];
            case 23:
              return [2];
          }
        });
      });
    }, e.prototype._requestUpdate = function (e) {
      return r(this, void 0, void 0, function () {
        var t, n, r, a, o, c, u, l;
        return s(this, function (s) {
          switch (s.label) {
            case 0:
              return t = e[this.keyName], [4, this._blockManager.getFromBlock(t)];
            case 1:
              return (n = s.sent()) ? [4, this._blockManager.putToBlock(t, e)] : [3, 11];
            case 2:
              s.sent(), s.label = 3;
            case 3:
              s.trys.push([3, 9, 10, 11]), r = i(this._indexers), a = r.next(), s.label = 4;
            case 4:
              return a.done ? [3, 8] : 0 === (o = a.value).diff(o.getColumnValues(n), o.getColumnValues(e)) ? [3, 7] : [4, o.removeItem(n)];
            case 5:
              return s.sent(), [4, o.addItem(e)];
            case 6:
              s.sent(), s.label = 7;
            case 7:
              return a = r.next(), [3, 4];
            case 8:
              return [3, 11];
            case 9:
              return c = s.sent(), u = {
                error: c
              }, [3, 11];
            case 10:
              try {
                a && !a.done && (l = r.return) && l.call(r);
              } finally {
                if (u) throw u.error;
              }
              return [7];
            case 11:
              return [2];
          }
        });
      });
    }, e.prototype._requestRemove = function (e) {
      return r(this, void 0, void 0, function () {
        var t, n, r, a, o, c;
        return s(this, function (s) {
          switch (s.label) {
            case 0:
              return [4, this._blockManager.getFromBlock(e)];
            case 1:
              return (t = s.sent()) ? [4, this._blockManager.removeFromBlock(e)] : [3, 10];
            case 2:
              s.sent(), s.label = 3;
            case 3:
              s.trys.push([3, 8, 9, 10]), n = i(this._indexers), r = n.next(), s.label = 4;
            case 4:
              return r.done ? [3, 7] : [4, r.value.removeItem(t)];
            case 5:
              s.sent(), s.label = 6;
            case 6:
              return r = n.next(), [3, 4];
            case 7:
              return [3, 10];
            case 8:
              return a = s.sent(), o = {
                error: a
              }, [3, 10];
            case 9:
              try {
                r && !r.done && (c = n.return) && c.call(n);
              } finally {
                if (o) throw o.error;
              }
              return [7];
            case 10:
              return [2];
          }
        });
      });
    }, e.prototype._requestClear = function () {
      return r(this, void 0, void 0, function () {
        var e, t, n, r, a;
        return s(this, function (s) {
          switch (s.label) {
            case 0:
              return [4, this._blockManager.clearAllBlocks()];
            case 1:
              s.sent(), s.label = 2;
            case 2:
              s.trys.push([2, 7, 8, 9]), e = i(this._indexers), t = e.next(), s.label = 3;
            case 3:
              return t.done ? [3, 6] : [4, t.value.clear()];
            case 4:
              s.sent(), s.label = 5;
            case 5:
              return t = e.next(), [3, 3];
            case 6:
              return [3, 9];
            case 7:
              return n = s.sent(), r = {
                error: n
              }, [3, 9];
            case 8:
              try {
                t && !t.done && (a = e.return) && a.call(e);
              } finally {
                if (r) throw r.error;
              }
              return [7];
            case 9:
              return [2];
          }
        });
      });
    }, e.prototype.getByKey = function (e) {
      return r(this, void 0, void 0, function () {
        var t, n;
        return s(this, function (r) {
          switch (r.label) {
            case 0:
              return this.isReady ? [4, this._mutex.lock()] : [3, 6];
            case 1:
              r.sent(), r.label = 2;
            case 2:
              return r.trys.push([2, 4,, 5]), [4, this._blockManager.getFromBlock(e)];
            case 3:
              return t = r.sent(), this._mutex.unlock(), [2, ke(t)];
            case 4:
              throw n = r.sent(), this._mutex.unlock(), n;
            case 5:
              return [3, 7];
            case 6:
              throw Se.collectionNotReady;
            case 7:
              return [2];
          }
        });
      });
    }, e.prototype.query = function (e) {
      if (void 0 === e && (e = {}), this.isReady) return new Ge({
        condition: e.where,
        mutex: this._mutex,
        blockManager: this._blockManager,
        indexer: this._getIndexerBy(e.index),
        backward: !!e.backward
      });
      throw Se.collectionNotReady;
    }, e.prototype.insertOne = function (e) {
      return r(this, void 0, void 0, function () {
        var t;
        return s(this, function (n) {
          switch (n.label) {
            case 0:
              return this.isReady ? [4, this._mutex.lock()] : [3, 8];
            case 1:
              n.sent(), n.label = 2;
            case 2:
              if (n.trys.push([2, 5,, 7]), !this._hasPropertyOfKeyName(e)) throw Se.collectionKeyNotGiven;
              return [4, this._requestInsert(ke(e))];
            case 3:
              return n.sent(), [4, this._transaction.commit()];
            case 4:
              return n.sent(), this._mutex.unlock(), [2, e];
            case 5:
              return t = n.sent(), [4, this._transaction.clear()];
            case 6:
              throw n.sent(), this._mutex.unlock(), t;
            case 7:
              return [3, 9];
            case 8:
              throw Se.collectionNotReady;
            case 9:
              return [2];
          }
        });
      });
    }, e.prototype.insertMany = function (e) {
      return r(this, void 0, void 0, function () {
        var t,
          n,
          r,
          a,
          o,
          c,
          u,
          l = this;
        return s(this, function (s) {
          switch (s.label) {
            case 0:
              return this.isReady ? [4, this._mutex.lock()] : [3, 15];
            case 1:
              s.sent(), s.label = 2;
            case 2:
              if (s.trys.push([2, 12,, 14]), e.some(function (e) {
                return !l._hasPropertyOfKeyName(e);
              })) throw Se.collectionKeyNotGiven;
              s.label = 3;
            case 3:
              s.trys.push([3, 8, 9, 10]), t = i(e), n = t.next(), s.label = 4;
            case 4:
              return n.done ? [3, 7] : (r = n.value, [4, this._requestInsert(ke(r))]);
            case 5:
              s.sent(), s.label = 6;
            case 6:
              return n = t.next(), [3, 4];
            case 7:
              return [3, 10];
            case 8:
              return a = s.sent(), c = {
                error: a
              }, [3, 10];
            case 9:
              try {
                n && !n.done && (u = t.return) && u.call(t);
              } finally {
                if (c) throw c.error;
              }
              return [7];
            case 10:
              return [4, this._transaction.commit()];
            case 11:
              return s.sent(), this._mutex.unlock(), [2, e];
            case 12:
              return o = s.sent(), [4, this._transaction.clear()];
            case 13:
              throw s.sent(), this._mutex.unlock(), o;
            case 14:
              return [3, 16];
            case 15:
              throw Se.collectionNotReady;
            case 16:
              return [2];
          }
        });
      });
    }, e.prototype.upsertOne = function (e) {
      return r(this, void 0, void 0, function () {
        var t;
        return s(this, function (n) {
          switch (n.label) {
            case 0:
              return this.isReady ? [4, this._mutex.lock()] : [3, 8];
            case 1:
              n.sent(), n.label = 2;
            case 2:
              if (n.trys.push([2, 5,, 7]), !this._hasPropertyOfKeyName(e)) throw Se.collectionKeyNotGiven;
              return [4, this._requestUpsert(ke(e))];
            case 3:
              return n.sent(), [4, this._transaction.commit()];
            case 4:
              return n.sent(), this._mutex.unlock(), [2, e];
            case 5:
              return t = n.sent(), [4, this._transaction.clear()];
            case 6:
              throw n.sent(), this._mutex.unlock(), t;
            case 7:
              return [3, 9];
            case 8:
              throw Se.collectionNotReady;
            case 9:
              return [2];
          }
        });
      });
    }, e.prototype.upsertMany = function (e) {
      return r(this, void 0, void 0, function () {
        var t,
          n,
          r,
          a,
          o,
          c,
          u,
          l = this;
        return s(this, function (s) {
          switch (s.label) {
            case 0:
              return this.isReady ? [4, this._mutex.lock()] : [3, 15];
            case 1:
              s.sent(), s.label = 2;
            case 2:
              if (s.trys.push([2, 12,, 14]), e.some(function (e) {
                return !l._hasPropertyOfKeyName(e);
              })) throw Se.collectionKeyNotGiven;
              s.label = 3;
            case 3:
              s.trys.push([3, 8, 9, 10]), t = i(e), n = t.next(), s.label = 4;
            case 4:
              return n.done ? [3, 7] : (r = n.value, [4, this._requestUpsert(ke(r))]);
            case 5:
              s.sent(), s.label = 6;
            case 6:
              return n = t.next(), [3, 4];
            case 7:
              return [3, 10];
            case 8:
              return a = s.sent(), c = {
                error: a
              }, [3, 10];
            case 9:
              try {
                n && !n.done && (u = t.return) && u.call(t);
              } finally {
                if (c) throw c.error;
              }
              return [7];
            case 10:
              return [4, this._transaction.commit()];
            case 11:
              return s.sent(), this._mutex.unlock(), [2, e];
            case 12:
              return o = s.sent(), [4, this._transaction.clear()];
            case 13:
              throw s.sent(), this._mutex.unlock(), o;
            case 14:
              return [3, 16];
            case 15:
              throw Se.collectionNotReady;
            case 16:
              return [2];
          }
        });
      });
    }, e.prototype.update = function (e) {
      return r(this, void 0, void 0, function () {
        var t;
        return s(this, function (n) {
          switch (n.label) {
            case 0:
              return this.isReady ? [4, this._mutex.lock()] : [3, 8];
            case 1:
              n.sent(), n.label = 2;
            case 2:
              if (n.trys.push([2, 5,, 7]), !this._hasPropertyOfKeyName(e)) throw Se.collectionKeyNotGiven;
              return [4, this._requestUpdate(ke(e))];
            case 3:
              return n.sent(), [4, this._transaction.commit()];
            case 4:
              return n.sent(), this._mutex.unlock(), [2, e];
            case 5:
              return t = n.sent(), [4, this._transaction.clear()];
            case 6:
              throw n.sent(), this._mutex.unlock(), t;
            case 7:
              return [3, 9];
            case 8:
              throw Se.collectionNotReady;
            case 9:
              return [2];
          }
        });
      });
    }, e.prototype.updateIf = function (e, t) {
      return r(this, void 0, void 0, function () {
        var n,
          a,
          o,
          c,
          u,
          l,
          h,
          d,
          f,
          _,
          v,
          p,
          m,
          y,
          b = this;
        return s(this, function (E) {
          switch (E.label) {
            case 0:
              return this.isReady ? [4, this._mutex.lock()] : [3, 16];
            case 1:
              E.sent(), E.label = 2;
            case 2:
              return E.trys.push([2, 13,, 15]), n = e.where, a = void 0 === n ? {} : n, o = e.index, c = void 0 === o ? null : o, u = e.backward, l = void 0 !== u && u, h = [], [4, new je({
                condition: a,
                blockManager: this._blockManager,
                backward: l,
                indexer: this._getIndexerBy(c)
              }).each(function (e) {
                return r(b, void 0, void 0, function () {
                  var n, r;
                  return s(this, function (i) {
                    if (e.error) throw e.stop(), e.error;
                    if (e.hasNext) {
                      if (n = e.nextValue, Pe(a, n) && t.set) {
                        if ("function" != typeof t.set) for (r in t.set) n[r] = t.set[r];else t.set(n);
                        h.push(n);
                      }
                      e.next();
                    } else e.stop();
                    return [2];
                  });
                });
              })];
            case 3:
              E.sent(), E.label = 4;
            case 4:
              E.trys.push([4, 9, 10, 11]), d = i(h), f = d.next(), E.label = 5;
            case 5:
              return f.done ? [3, 8] : (_ = f.value, [4, this._requestUpdate(ke(_))]);
            case 6:
              E.sent(), E.label = 7;
            case 7:
              return f = d.next(), [3, 5];
            case 8:
              return [3, 11];
            case 9:
              return v = E.sent(), m = {
                error: v
              }, [3, 11];
            case 10:
              try {
                f && !f.done && (y = d.return) && y.call(d);
              } finally {
                if (m) throw m.error;
              }
              return [7];
            case 11:
              return [4, this._transaction.commit()];
            case 12:
              return E.sent(), this._mutex.unlock(), [2, h];
            case 13:
              return p = E.sent(), [4, this._transaction.clear()];
            case 14:
              throw E.sent(), this._mutex.unlock(), p;
            case 15:
              return [3, 17];
            case 16:
              throw this._transaction.clear(), Se.collectionNotReady;
            case 17:
              return [2];
          }
        });
      });
    }, e.prototype.remove = function (e) {
      return r(this, void 0, void 0, function () {
        var t;
        return s(this, function (n) {
          switch (n.label) {
            case 0:
              return this.isReady ? [4, this._mutex.lock()] : [3, 8];
            case 1:
              n.sent(), n.label = 2;
            case 2:
              return n.trys.push([2, 5,, 7]), [4, this._requestRemove(e)];
            case 3:
              return n.sent(), [4, this._transaction.commit()];
            case 4:
              return n.sent(), this._mutex.unlock(), [3, 7];
            case 5:
              return t = n.sent(), [4, this._transaction.clear()];
            case 6:
              throw n.sent(), this._mutex.unlock(), t;
            case 7:
              return [3, 9];
            case 8:
              throw Se.collectionNotReady;
            case 9:
              return [2];
          }
        });
      });
    }, e.prototype.removeIf = function (e) {
      return r(this, void 0, void 0, function () {
        var t,
          n,
          a,
          o,
          c,
          u,
          l,
          h,
          d,
          f,
          _,
          v,
          p,
          m,
          y = this;
        return s(this, function (b) {
          switch (b.label) {
            case 0:
              return this.isReady ? [4, this._mutex.lock()] : [3, 15];
            case 1:
              b.sent(), b.label = 2;
            case 2:
              return b.trys.push([2, 13,, 14]), t = e.where, n = void 0 === t ? {} : t, a = e.index, o = void 0 === a ? null : a, c = e.backward, u = void 0 !== c && c, l = [], [4, new je({
                condition: n,
                blockManager: this._blockManager,
                backward: u,
                indexer: this._getIndexerBy(o)
              }).each(function (e) {
                return r(y, void 0, void 0, function () {
                  var t, r;
                  return s(this, function (i) {
                    if (e.error) throw e.stop(), e.error;
                    return e.hasNext ? (t = e.nextValue, Pe(n, t) && (r = t[this.keyName], l.push(r)), e.next()) : e.stop(), [2];
                  });
                });
              })];
            case 3:
              b.sent(), b.label = 4;
            case 4:
              b.trys.push([4, 9, 10, 11]), h = i(l), d = h.next(), b.label = 5;
            case 5:
              return d.done ? [3, 8] : (f = d.value, [4, this._requestRemove(f)]);
            case 6:
              b.sent(), b.label = 7;
            case 7:
              return d = h.next(), [3, 5];
            case 8:
              return [3, 11];
            case 9:
              return _ = b.sent(), p = {
                error: _
              }, [3, 11];
            case 10:
              try {
                d && !d.done && (m = h.return) && m.call(h);
              } finally {
                if (p) throw p.error;
              }
              return [7];
            case 11:
              return [4, this._transaction.commit()];
            case 12:
              return b.sent(), this._mutex.unlock(), [2, l];
            case 13:
              throw v = b.sent(), this._mutex.unlock(), v;
            case 14:
              return [3, 16];
            case 15:
              throw this._transaction.clear(), Se.collectionNotReady;
            case 16:
              return [2];
          }
        });
      });
    }, e.prototype.clear = function () {
      return r(this, void 0, void 0, function () {
        var e;
        return s(this, function (t) {
          switch (t.label) {
            case 0:
              return this.isReady ? [4, this._mutex.lock()] : [3, 8];
            case 1:
              t.sent(), t.label = 2;
            case 2:
              return t.trys.push([2, 5,, 7]), [4, this._requestClear()];
            case 3:
              return t.sent(), [4, this._transaction.commit()];
            case 4:
              return t.sent(), this._mutex.unlock(), [3, 7];
            case 5:
              return e = t.sent(), [4, this._transaction.clear()];
            case 6:
              throw t.sent(), this._mutex.unlock(), e;
            case 7:
              return [3, 9];
            case 8:
              throw Se.collectionNotReady;
            case 9:
              return [2];
          }
        });
      });
    }, e.prototype.getBlob = function (e) {
      return r(this, void 0, void 0, function () {
        return s(this, function (t) {
          switch (t.label) {
            case 0:
              return [4, this._blobContainer.get(e)];
            case 1:
              return [2, t.sent()];
          }
        });
      });
    }, e.prototype.saveBlob = function (e, t) {
      return r(this, void 0, void 0, function () {
        return s(this, function (n) {
          switch (n.label) {
            case 0:
              return [4, this._blobContainer.save(e, t)];
            case 1:
              return [2, n.sent()];
          }
        });
      });
    }, e.prototype.removeBlob = function (e) {
      return r(this, void 0, void 0, function () {
        return s(this, function (t) {
          switch (t.label) {
            case 0:
              return [4, this._blobContainer.remove(e)];
            case 1:
              return t.sent(), [2];
          }
        });
      });
    }, e.prototype.removeAllBlobs = function () {
      return r(this, void 0, void 0, function () {
        return s(this, function (e) {
          switch (e.label) {
            case 0:
              return [4, this._blobContainer.clear()];
            case 1:
              return e.sent(), [2];
          }
        });
      });
    }, e;
  }(),
  ct = function () {
    function e(e) {
      var t, n, r;
      this.encryption = null !== (t = e.encryption) && void 0 !== t ? t : A, this.itemSizeLimit = null !== (n = e.itemSizeLimit) && void 0 !== n ? n : 4194304, this.metadataBuffer = null !== (r = e.metadataBuffer) && void 0 !== r ? r : 256;
    }
    return e.prototype._getRawKey = function (e, t) {
      return void 0 === t && (t = ""), "".concat(e).concat(t);
    }, e.prototype._generateShardPostfixArray = function (e) {
      return void 0 === e && (e = 1), I([], w(Array(e).keys()), !1);
    }, e.prototype._shardify = function (e) {
      var t = this,
        n = e.key,
        r = e.value,
        i = JSON.stringify(this.encryption.encrypt(r)),
        s = Math.ceil(i.length / this.adjustedItemSizeLimit);
      return this._generateShardPostfixArray(s).map(function (e) {
        var r = {
          key: t._getRawKey(n, ".".concat(e)),
          data: i.substring(e * t.adjustedItemSizeLimit, (e + 1) * t.adjustedItemSizeLimit)
        };
        return 0 === e && (r.metadata = {
          shards: s
        }), r;
      });
    }, Object.defineProperty(e.prototype, "adjustedItemSizeLimit", {
      get: function get() {
        return Math.max(this.itemSizeLimit - this.metadataBuffer, 4);
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.usage = function () {
      return r(this, void 0, void 0, function () {
        var e, t, n, r, a, o, c, u, l;
        return s(this, function (s) {
          switch (s.label) {
            case 0:
              return e = 0, [4, this._getAllRawKeys()];
            case 1:
              t = s.sent(), s.label = 2;
            case 2:
              s.trys.push([2, 7, 8, 9]), n = i(t), r = n.next(), s.label = 3;
            case 3:
              return r.done ? [3, 6] : (a = r.value, [4, this._getRaw(a)]);
            case 4:
              (o = s.sent()) && (e += JSON.stringify(o).length), s.label = 5;
            case 5:
              return r = n.next(), [3, 3];
            case 6:
              return [3, 9];
            case 7:
              return c = s.sent(), u = {
                error: c
              }, [3, 9];
            case 8:
              try {
                r && !r.done && (l = n.return) && l.call(n);
              } finally {
                if (u) throw u.error;
              }
              return [7];
            case 9:
              return [2, e];
          }
        });
      });
    }, e.prototype.getAllKeys = function () {
      return r(this, void 0, void 0, function () {
        return s(this, function (e) {
          switch (e.label) {
            case 0:
              return [4, this._getAllRawKeys()];
            case 1:
              return [2, e.sent().filter(function (e) {
                return e.endsWith(".0");
              }).map(function (e) {
                return e.replace(/\.0$/, "");
              })];
          }
        });
      });
    }, e.prototype.get = function (e) {
      return r(this, void 0, void 0, function () {
        var t,
          n,
          i,
          a,
          o,
          c,
          u = this;
        return s(this, function (l) {
          switch (l.label) {
            case 0:
              return t = this._getRawKey(e, ".0"), [4, this._getRaw(t)];
            case 1:
              if (!(n = l.sent())) return [3, 7];
              l.label = 2;
            case 2:
              return l.trys.push([2, 6,, 7]), i = n.data, (null == (a = n.metadata) ? void 0 : a.shards) && a.shards > 1 ? [4, Promise.all(this._generateShardPostfixArray(null == a ? void 0 : a.shards).map(function (t) {
                return r(u, void 0, void 0, function () {
                  var n, r;
                  return s(this, function (s) {
                    switch (s.label) {
                      case 0:
                        return t > 0 ? (n = this._getRawKey(e, ".".concat(t)), [4, this._getRaw(n)]) : [3, 2];
                      case 1:
                        if (!(r = s.sent())) throw Se.storeBrokenIntegrity;
                        return [2, r.data];
                      case 2:
                        return [2, i];
                    }
                  });
                });
              }))] : [3, 4];
            case 3:
              return c = l.sent(), [3, 5];
            case 4:
              c = [i], l.label = 5;
            case 5:
              return o = c, [2, this.encryption.decrypt(JSON.parse(o.join("")))];
            case 6:
              return l.sent(), [2, null];
            case 7:
              return [2, null];
          }
        });
      });
    }, e.prototype.set = function (e) {
      return r(this, void 0, void 0, function () {
        var t;
        return s(this, function (n) {
          switch (n.label) {
            case 0:
              return t = this._shardify(e), [4, this._setRaw(t)];
            case 1:
              return n.sent(), [2, a({}, e.value)];
          }
        });
      });
    }, e.prototype.setMany = function (e) {
      return r(this, void 0, void 0, function () {
        var t,
          n = this;
        return s(this, function (r) {
          switch (r.label) {
            case 0:
              return t = [], [4, this._setRaw(t.concat.apply(t, I([], w(e.map(function (e) {
                return n._shardify(e);
              })), !1)))];
            case 1:
              return r.sent(), [2, e.map(function (e) {
                return e.value;
              })];
          }
        });
      });
    }, e.prototype.remove = function (e) {
      return r(this, void 0, void 0, function () {
        var t,
          n,
          r,
          i = this;
        return s(this, function (s) {
          switch (s.label) {
            case 0:
              return t = this._getRawKey(e, ".0"), [4, this._getRaw(t)];
            case 1:
              return (n = s.sent()) ? (r = n.metadata, [4, this._removeRaw(this._generateShardPostfixArray(null == r ? void 0 : r.shards).map(function (t) {
                return i._getRawKey(e, ".".concat(t));
              }))]) : [3, 3];
            case 2:
              return s.sent(), [2, !0];
            case 3:
              return [2, !1];
          }
        });
      });
    }, e.prototype.removeMany = function (e) {
      return r(this, void 0, void 0, function () {
        var t,
          n,
          r,
          a,
          o,
          c,
          u,
          l,
          h,
          d = this;
        return s(this, function (f) {
          switch (f.label) {
            case 0:
              t = [], n = function n(e) {
                var n, i, a;
                return s(this, function (s) {
                  switch (s.label) {
                    case 0:
                      return n = r._getRawKey(e, ".0"), [4, r._getRaw(n)];
                    case 1:
                      return (i = s.sent()) && (a = i.metadata, t.push.apply(t, I([], w(r._generateShardPostfixArray(null == a ? void 0 : a.shards).map(function (t) {
                        return d._getRawKey(e, ".".concat(t));
                      })), !1))), [2];
                  }
                });
              }, r = this, f.label = 1;
            case 1:
              f.trys.push([1, 6, 7, 8]), a = i(e), o = a.next(), f.label = 2;
            case 2:
              return o.done ? [3, 5] : (c = o.value, [5, n(c)]);
            case 3:
              f.sent(), f.label = 4;
            case 4:
              return o = a.next(), [3, 2];
            case 5:
              return [3, 8];
            case 6:
              return u = f.sent(), l = {
                error: u
              }, [3, 8];
            case 7:
              try {
                o && !o.done && (h = a.return) && h.call(a);
              } finally {
                if (l) throw l.error;
              }
              return [7];
            case 8:
              return t.length > 0 ? [4, this._removeRaw(t)] : [3, 10];
            case 9:
              f.sent(), f.label = 10;
            case 10:
              return [2, e];
          }
        });
      });
    }, e;
  }(),
  ut = {},
  lt = function (e) {
    function t(t) {
      void 0 === t && (t = {});
      var n,
        r = this;
      r = e.call(this, a(a({}, t), {
        itemSizeLimit: null !== (n = t.itemSizeLimit) && void 0 !== n ? n : 4194304
      })) || this;
      var i = t.delay,
        s = void 0 === i ? 1 : i;
      return r.delay = s, r.observer = {}, r;
    }
    return u(t, e), Object.defineProperty(t.prototype, "rawData", {
      get: function get() {
        return ut[this.dbname];
      },
      set: function set(e) {
        ut[this.dbname] = e;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype._getAllRawKeys = function () {
      return r(this, void 0, void 0, function () {
        return s(this, function (e) {
          if (ut[this.dbname]) return [2, Object.keys(ut[this.dbname])];
          throw Se.storeNotAvailable;
        });
      });
    }, t.prototype._getRaw = function (e) {
      return r(this, void 0, void 0, function () {
        return s(this, function (t) {
          switch (t.label) {
            case 0:
              return ut[this.dbname] ? [4, De(this.delay)] : [3, 2];
            case 1:
              return t.sent(), [2, ut[this.dbname][e] ? a({
                key: e
              }, ut[this.dbname][e]) : null];
            case 2:
              throw Se.storeNotAvailable;
          }
        });
      });
    }, t.prototype._setRaw = function (e) {
      return r(this, void 0, void 0, function () {
        var t, n, r, a, o, c, u, l;
        return s(this, function (s) {
          switch (s.label) {
            case 0:
              return ut[this.dbname] ? [4, De(this.delay)] : [3, 2];
            case 1:
              s.sent();
              try {
                for (t = i(e), n = t.next(); !n.done; n = t.next()) r = n.value, a = r.key, o = r.data, c = r.metadata, ut[this.dbname][a] = Object.freeze({
                  data: o,
                  metadata: c
                });
              } catch (e) {
                u = {
                  error: e
                };
              } finally {
                try {
                  n && !n.done && (l = t.return) && l.call(t);
                } finally {
                  if (u) throw u.error;
                }
              }
              return [3, 3];
            case 2:
              throw Se.storeNotAvailable;
            case 3:
              return [2];
          }
        });
      });
    }, t.prototype._removeRaw = function (e) {
      return r(this, void 0, void 0, function () {
        var t, n, r, a, o;
        return s(this, function (s) {
          switch (s.label) {
            case 0:
              return ut[this.dbname] ? [4, De(this.delay)] : [3, 2];
            case 1:
              s.sent();
              try {
                for (t = i(e), n = t.next(); !n.done; n = t.next()) r = n.value, ut[this.dbname][r] && delete ut[this.dbname][r];
              } catch (e) {
                a = {
                  error: e
                };
              } finally {
                try {
                  n && !n.done && (o = t.return) && o.call(t);
                } finally {
                  if (a) throw a.error;
                }
              }
              return [3, 3];
            case 2:
              throw Se.storeNotAvailable;
            case 3:
              return [2];
          }
        });
      });
    }, t.prototype.observe = function (e, t, n) {
      var r = this;
      this.observer[e] || (this.observer[e] = {}), t.forEach(function (t) {
        return r.observer[e][t] = n;
      });
    }, t.prototype.checkAvailability = function () {
      return r(this, void 0, void 0, function () {
        return s(this, function (e) {
          return [2];
        });
      });
    }, t.prototype.init = function (e) {
      return r(this, void 0, void 0, function () {
        return s(this, function (t) {
          return this.dbname = e, ut[this.dbname] = {}, [2];
        });
      });
    }, t.prototype.set = function (t) {
      return r(this, void 0, void 0, function () {
        var n, r;
        return s(this, function (i) {
          if ((n = this.observer[t.key]) && "function" == typeof n.set && (r = n.set())) throw r;
          return [2, e.prototype.set.call(this, t)];
        });
      });
    }, t.prototype.setMany = function (t) {
      return r(this, void 0, void 0, function () {
        var n, r, a, o, c, u, l;
        return s(this, function (s) {
          try {
            for (n = i(t), r = n.next(); !r.done; r = n.next()) if (a = r.value, (o = this.observer[a.key]) && "function" == typeof o.set && (c = o.set())) throw c;
          } catch (e) {
            u = {
              error: e
            };
          } finally {
            try {
              r && !r.done && (l = n.return) && l.call(n);
            } finally {
              if (u) throw u.error;
            }
          }
          return [2, e.prototype.setMany.call(this, t)];
        });
      });
    }, t.prototype.clear = function () {
      return r(this, void 0, void 0, function () {
        return s(this, function (e) {
          switch (e.label) {
            case 0:
              return [4, De(this.delay)];
            case 1:
              return e.sent(), ut[this.dbname] = {}, [2];
          }
        });
      });
    }, t;
  }(ct),
  ht = "NestDBStore";
!function (e) {
  e[e.UNINITIALIZED = 0] = "UNINITIALIZED", e[e.OPENING = 1] = "OPENING", e[e.OPEN = 2] = "OPEN", e[e.CLOSED = 3] = "CLOSED";
}(Xe || (Xe = {}));
var dt = function (e) {
    function t(t) {
      void 0 === t && (t = {});
      var n,
        r = this;
      return (r = e.call(this, a(a({}, t), {
        itemSizeLimit: null !== (n = t.itemSizeLimit) && void 0 !== n ? n : 104857600
      })) || this)._storeName = ht, r._state = Xe.UNINITIALIZED, r._openJobQueue = [], r._window = "undefined" != typeof window ? window : void 0, r._indexedDb = r._window ? r._window.indexedDB || r._window.mozIndexedDB || r._window.webkitIndexedDB || r._window.msIndexedDB : void 0, r;
    }
    return u(t, e), Object.defineProperty(t.prototype, "state", {
      get: function get() {
        return this._state;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype._openDatabase = function (e) {
      var t = this;
      return new Promise(function (n, r) {
        if (t._indexedDb) {
          t._state = Xe.OPENING;
          var i = t._indexedDb.open(e);
          i.addEventListener("upgradeneeded", function (e) {
            e.target.result.createObjectStore(ht, {
              keyPath: "key"
            });
          }), i.addEventListener("success", function (r) {
            t._state = Xe.OPEN, t._database = r.target.result, t._openJobQueue.forEach(function (e) {
              return e();
            }), t._openJobQueue = [], t._database.onclose = function () {
              t._database = void 0, t._state = Xe.OPENING, setTimeout(function () {
                t._openDatabase(e);
              }, 5);
            }, n(t._database);
          }), i.addEventListener("error", function (e) {
            t._state = Xe.UNINITIALIZED, r(e.target.error);
          });
        } else r(Se.storeNotAvailable);
      });
    }, t.prototype._getObjectStore = function (e) {
      return r(this, void 0, void 0, function () {
        var t = this;
        return s(this, function (n) {
          switch (n.label) {
            case 0:
              return this._database ? [2, this._database.transaction(this._storeName, e).objectStore(this._storeName)] : [3, 1];
            case 1:
              switch (this._state) {
                case Xe.UNINITIALIZED:
                case Xe.OPEN:
                  return [3, 2];
                case Xe.OPENING:
                case Xe.CLOSED:
                  return [3, 3];
              }
              return [3, 4];
            case 2:
              throw Se.storeNotInitialized;
            case 3:
              return [2, new Promise(function (n) {
                t._openJobQueue.push(function () {
                  return n(t._getObjectStore(e));
                });
              })];
            case 4:
              return [4, this._getObjectStore(e)];
            case 5:
              return [2, n.sent()];
          }
        });
      });
    }, t.prototype._getAllRawKeys = function () {
      return r(this, void 0, void 0, function () {
        var e;
        return s(this, function (t) {
          switch (t.label) {
            case 0:
              return [4, this._getObjectStore("readonly")];
            case 1:
              return e = t.sent(), [4, new Promise(function (t, n) {
                var r = e.getAllKeys();
                r.addEventListener("success", function (e) {
                  t(e.target.result);
                }), r.addEventListener("error", function (e) {
                  return n(e.target.error);
                });
              })];
            case 2:
              return [2, t.sent()];
          }
        });
      });
    }, t.prototype._getRaw = function (e) {
      return r(this, void 0, void 0, function () {
        var t;
        return s(this, function (n) {
          switch (n.label) {
            case 0:
              return [4, this._getObjectStore("readonly")];
            case 1:
              return t = n.sent(), [4, new Promise(function (n, r) {
                var i = t.get(e);
                i.addEventListener("success", function (e) {
                  var t;
                  n(null === (t = null == e ? void 0 : e.target) || void 0 === t ? void 0 : t.result);
                }), i.addEventListener("error", function (e) {
                  return r(e.target.error);
                });
              })];
            case 2:
              return [2, n.sent()];
          }
        });
      });
    }, t.prototype._setRaw = function (e) {
      return r(this, void 0, void 0, function () {
        var t;
        return s(this, function (n) {
          switch (n.label) {
            case 0:
              return [4, this._getObjectStore("readwrite")];
            case 1:
              return t = n.sent(), [4, Promise.all(e.map(function (e) {
                return new Promise(function (n, r) {
                  var i = t.put(e);
                  i.addEventListener("success", function (e) {
                    n(e.target.result);
                  }), i.addEventListener("error", function () {
                    r("Failed to write.");
                  });
                });
              }))];
            case 2:
              return n.sent(), [2];
          }
        });
      });
    }, t.prototype._removeRaw = function (e) {
      return r(this, void 0, void 0, function () {
        var t;
        return s(this, function (n) {
          switch (n.label) {
            case 0:
              return [4, this._getObjectStore("readwrite")];
            case 1:
              return t = n.sent(), [4, Promise.all(e.map(function (e) {
                return new Promise(function (n, r) {
                  var i = t.delete(e);
                  i.addEventListener("success", function () {
                    return n(e);
                  }), i.addEventListener("error", function (e) {
                    return r(e.target.error);
                  });
                });
              }))];
            case 2:
              return n.sent(), [2];
          }
        });
      });
    }, t.prototype._triggerDatabaseClose = function () {
      this._database && this._database.onclose && this._database.onclose(new Event("dummy"));
    }, t.prototype.checkAvailability = function () {
      return r(this, void 0, void 0, function () {
        var e,
          t = this;
        return s(this, function (n) {
          switch (n.label) {
            case 0:
              if (!((null == (e = "undefined" != typeof window ? window : null) ? void 0 : e.indexedDB) || (null == e ? void 0 : e.mozIndexedDB) || (null == e ? void 0 : e.webkitIndexedDB) || (null == e ? void 0 : e.msIndexedDB))) return [3, 6];
              if (this._indexedDb = e.indexedDB || e.mozIndexedDB || e.webkitIndexedDB || e.msIndexedDB, !this._window || !$()) return [3, 4];
              if (!($() && navigator.userAgent && navigator.userAgent.includes("Edge/"))) return [3, 1];
              if (!this._window.indexedDB && (e.PointerEvent || e.MSPointerEvent)) throw Se.storeNotAvailableInPrivateBrowsing;
              return [3, 3];
            case 1:
              return [4, new Promise(function (e, n) {
                if (t._indexedDb) try {
                  var r = t._indexedDb.open("_testMozilla");
                  r.onerror = function () {
                    return n(Se.storeNotAvailableInPrivateBrowsing);
                  }, r.onsuccess = function () {
                    return e();
                  };
                } catch (e) {
                  n(Se.storeNotAvailableInPrivateBrowsing);
                } else n(Se.storeNotAvailable);
              })];
            case 2:
              n.sent(), n.label = 3;
            case 3:
              return [3, 5];
            case 4:
              throw Se.storeNotAvailable;
            case 5:
              return [3, 7];
            case 6:
              throw Se.storeNotAvailable;
            case 7:
              return [2];
          }
        });
      });
    }, t.prototype.init = function (e) {
      return r(this, void 0, void 0, function () {
        return s(this, function (t) {
          switch (t.label) {
            case 0:
              return this.dbname = e, [4, this.checkAvailability()];
            case 1:
              return t.sent(), [4, this._openDatabase(e)];
            case 2:
              return t.sent(), [2];
          }
        });
      });
    }, t.prototype.clear = function () {
      return r(this, void 0, void 0, function () {
        var e;
        return s(this, function (t) {
          switch (t.label) {
            case 0:
              return [4, this._getObjectStore("readwrite")];
            case 1:
              return e = t.sent(), [4, new Promise(function (t, n) {
                var r = e.clear();
                r.addEventListener("success", function () {
                  return t();
                }), r.addEventListener("error", function (e) {
                  return n(e.target.error);
                });
              })];
            case 2:
              return [2, t.sent()];
          }
        });
      });
    }, t;
  }(ct),
  ft = function (e) {
    function t(t) {
      var n = this,
        r = t.AsyncStorage,
        i = t.itemSizeLimit,
        s = void 0 === i ? 6291456 : i,
        o = T(t, ["AsyncStorage", "itemSizeLimit"]);
      return (n = e.call(this, a(a({}, o), {
        itemSizeLimit: s
      })) || this)._asyncStorage = r, n;
    }
    return u(t, e), t.prototype._isBelonging = function (e) {
      return e.startsWith("".concat(this.dbname, "/"));
    }, t.prototype._getActualKey = function (e) {
      return "".concat(this.dbname, "/").concat(e);
    }, t.prototype._getAllRawKeys = function () {
      return r(this, void 0, void 0, function () {
        var e,
          t = this;
        return s(this, function (n) {
          switch (n.label) {
            case 0:
              return [4, this._asyncStorage.getAllKeys()];
            case 1:
              return e = n.sent(), [2, e.filter(function (e) {
                return t._isBelonging(e);
              }).map(function (e) {
                return e.substring("".concat(t.dbname, "/").length);
              })];
          }
        });
      });
    }, t.prototype._getRaw = function (e) {
      return r(this, void 0, void 0, function () {
        var t;
        return s(this, function (n) {
          switch (n.label) {
            case 0:
              return [4, this._asyncStorage.getItem(this._getActualKey(e))];
            case 1:
              return [2, (t = n.sent()) ? JSON.parse(t) : null];
          }
        });
      });
    }, t.prototype._setRaw = function (e) {
      return r(this, void 0, void 0, function () {
        var t, n, r, a, o, c, u;
        return s(this, function (s) {
          switch (s.label) {
            case 0:
              t = [];
              try {
                for (n = i(e), r = n.next(); !r.done; r = n.next()) a = r.value, o = a.key, a.data.length <= this.adjustedItemSizeLimit && t.push([this._getActualKey(o), JSON.stringify(a)]);
              } catch (e) {
                c = {
                  error: e
                };
              } finally {
                try {
                  r && !r.done && (u = n.return) && u.call(n);
                } finally {
                  if (c) throw c.error;
                }
              }
              return [4, this._asyncStorage.multiSet(t)];
            case 1:
              return s.sent(), [2];
          }
        });
      });
    }, t.prototype._removeRaw = function (e) {
      return r(this, void 0, void 0, function () {
        var t = this;
        return s(this, function (n) {
          switch (n.label) {
            case 0:
              return [4, this._asyncStorage.multiRemove(e.map(function (e) {
                return t._getActualKey(e);
              }))];
            case 1:
              return n.sent(), [2];
          }
        });
      });
    }, t.prototype.checkAvailability = function () {
      return r(this, void 0, void 0, function () {
        return s(this, function (e) {
          if (!this._asyncStorage) throw Se.storeNotAvailable;
          return [2];
        });
      });
    }, t.prototype.init = function (e) {
      return r(this, void 0, void 0, function () {
        return s(this, function (t) {
          return this.dbname = e, [2];
        });
      });
    }, t.prototype.clear = function () {
      return r(this, void 0, void 0, function () {
        var e;
        return s(this, function (t) {
          switch (t.label) {
            case 0:
              return [4, this.getAllKeys()];
            case 1:
              return e = t.sent(), [4, this.removeMany(e)];
            case 2:
              return t.sent(), [2];
          }
        });
      });
    }, t;
  }(ct);
!function (e) {
  function t(t) {
    var n,
      r = this;
    return (r = e.call(this, a(a({}, t), {
      itemSizeLimit: null !== (n = t.itemSizeLimit) && void 0 !== n ? n : 6291456
    })) || this)._mmkv = t.MMKV, r;
  }
  u(t, e), t.prototype._isBelonging = function (e) {
    return e.startsWith("".concat(this.dbname, "/"));
  }, t.prototype._getActualKey = function (e) {
    return "".concat(this.dbname, "/").concat(e);
  }, t.prototype._getAllRawKeys = function () {
    return r(this, void 0, void 0, function () {
      var e,
        t = this;
      return s(this, function (n) {
        switch (n.label) {
          case 0:
            return [4, this._mmkv.getAllKeys()];
          case 1:
            return e = n.sent(), [2, e.filter(function (e) {
              return t._isBelonging(e);
            }).map(function (e) {
              return e.substring("".concat(t.dbname, "/").length);
            })];
        }
      });
    });
  }, t.prototype._getRaw = function (e) {
    return r(this, void 0, void 0, function () {
      var t;
      return s(this, function (n) {
        switch (n.label) {
          case 0:
            return [4, this._mmkv.getString(this._getActualKey(e))];
          case 1:
            return [2, (t = n.sent()) ? JSON.parse(t) : null];
        }
      });
    });
  }, t.prototype._setRaw = function (e) {
    return r(this, void 0, void 0, function () {
      var t, n, r, a, o, c;
      return s(this, function (s) {
        try {
          for (t = i(e), n = t.next(); !n.done; n = t.next()) r = n.value, a = r.key, r.data.length <= this.adjustedItemSizeLimit && this._mmkv.set(this._getActualKey(a), JSON.stringify(r));
        } catch (e) {
          o = {
            error: e
          };
        } finally {
          try {
            n && !n.done && (c = t.return) && c.call(t);
          } finally {
            if (o) throw o.error;
          }
        }
        return [2];
      });
    });
  }, t.prototype._removeRaw = function (e) {
    return r(this, void 0, void 0, function () {
      var t, n, r, a, o;
      return s(this, function (s) {
        try {
          for (t = i(e), n = t.next(); !n.done; n = t.next()) r = n.value, this._mmkv.delete(this._getActualKey(r));
        } catch (e) {
          a = {
            error: e
          };
        } finally {
          try {
            n && !n.done && (o = t.return) && o.call(t);
          } finally {
            if (a) throw a.error;
          }
        }
        return [2];
      });
    });
  }, t.prototype.checkAvailability = function () {
    return r(this, void 0, void 0, function () {
      return s(this, function (e) {
        if (!this._mmkv) throw Se.storeNotAvailable;
        return [2];
      });
    });
  }, t.prototype.init = function (e) {
    return r(this, void 0, void 0, function () {
      return s(this, function (t) {
        return this.dbname = e, [2];
      });
    });
  }, t.prototype.clear = function () {
    return r(this, void 0, void 0, function () {
      var e;
      return s(this, function (t) {
        switch (t.label) {
          case 0:
            return [4, this.getAllKeys()];
          case 1:
            return e = t.sent(), [4, this.removeMany(e)];
          case 2:
            return t.sent(), [2];
        }
      });
    });
  };
}(ct);
var _t,
  vt = "[NESTDB]",
  pt = !0,
  mt = function () {
    function e() {}
    return e.off = function () {
      pt = !1;
    }, e.log = function () {
      for (var e = [], t = 0; t < arguments.length; t++) e[t] = arguments[t];
      pt && console.log.apply(console, I(["".concat(vt, "[LOG]")], w(e), !1));
    }, e.warning = function () {
      for (var e = [], t = 0; t < arguments.length; t++) e[t] = arguments[t];
      pt && console.warn.apply(console, I(["".concat(vt, "[WARNING]")], w(e), !1));
    }, e.error = function () {
      for (var e = [], t = 0; t < arguments.length; t++) e[t] = arguments[t];
      pt && console.error.apply(console, I(["".concat(vt, "[ERROR]")], w(e), !1));
    }, e;
  }();
!function (e) {
  e.INIT = "INIT", e.OPENING = "OPENING", e.OPENED = "OPENED", e.CLOSED = "CLOSED";
}(_t || (_t = {}));
var yt = function () {
  function e(e) {
    var t = e.name,
      n = e.version,
      r = e.store,
      i = e.config;
    this.name = t, this._version = n, this._state = _t.INIT, this._config = i || new Oe({
      dbname: t
    }), this._store = r, this._event = {
      success: Me,
      error: Me,
      storeReplaced: Me,
      upgrade: Ue
    }, this._collections = new Map(), this._globalMutex = new re("".concat(this.name, ".lock")), this._config.disableLogger && mt.off(), new tt({
      dbname: t,
      limit: this._config.cacheLimit
    });
  }
  return Object.defineProperty(e.prototype, "version", {
    get: function get() {
      return this._version;
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(e.prototype, "state", {
    get: function get() {
      return this._state;
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(e.prototype, "store", {
    get: function get() {
      return this._store;
    },
    enumerable: !1,
    configurable: !0
  }), e.prototype.estimateUsage = function () {
    return r(this, void 0, void 0, function () {
      return s(this, function (e) {
        switch (e.label) {
          case 0:
            return [4, (t = this._store, r(void 0, void 0, void 0, function () {
              return s(this, function (e) {
                switch (e.label) {
                  case 0:
                    return [4, t.usage()];
                  case 1:
                    return [2, e.sent()];
                }
              });
            }))];
          case 1:
            return [2, e.sent()];
        }
        var t;
      });
    });
  }, e.prototype.commitSchema = function (e) {
    return r(this, void 0, void 0, function () {
      var t = this;
      return s(this, function (n) {
        switch (n.label) {
          case 0:
            return this._state !== _t.OPENING ? [3, 2] : [4, Promise.all(e.map(function (e) {
              return r(t, void 0, void 0, function () {
                var t, n, r, i, a;
                return s(this, function (s) {
                  switch (s.label) {
                    case 0:
                      return t = e.collectionName, n = e.keyName, r = e.index, i = void 0 === r ? [] : r, this._collections.has(t) || this._collections.set(t, new ot({
                        dbname: this.name,
                        collectionName: t,
                        keyName: n,
                        indexes: i,
                        store: this._store
                      })), (a = this._collections.get(t)) ? [4, a.init()] : [3, 2];
                    case 1:
                      s.sent(), s.label = 2;
                    case 2:
                      return [2];
                  }
                });
              });
            }))];
          case 1:
            return n.sent(), [3, 3];
          case 2:
            throw Se.databaseSchemaNotOnUpgrade;
          case 3:
            return [2];
        }
      });
    });
  }, e.prototype.open = function () {
    var e;
    return r(this, void 0, void 0, function () {
      var t,
        n,
        i,
        a,
        o = this;
      return s(this, function (c) {
        switch (c.label) {
          case 0:
            return [4, this._globalMutex.lock()];
          case 1:
            if (c.sent(), this._state === _t.OPENED) return [3, 15];
            this._state = _t.OPENING, c.label = 2;
          case 2:
            return c.trys.push([2, 5,, 15]), [4, this._store.init(this.name)];
          case 3:
            return c.sent(), u = this.name, t = "".concat(ze(u), ".metadata"), n = {
              version: 0,
              collectionNames: []
            }, [4, this._store.get(t)];
          case 4:
            return i = null !== (e = c.sent()) && void 0 !== e ? e : n, [2, new Promise(function (e, n) {
              var a = function a(e) {
                  i.version < o._version ? o._event.upgrade(i.version, function (n) {
                    return r(o, void 0, void 0, function () {
                      var r;
                      return s(this, function (s) {
                        switch (s.label) {
                          case 0:
                            if (n) return [3, 5];
                            i.version++, i.collectionNames = Array.from(this._collections.keys()), s.label = 1;
                          case 1:
                            return s.trys.push([1, 3,, 4]), [4, this._store.set({
                              key: t,
                              value: i
                            })];
                          case 2:
                            return s.sent(), e({
                              continued: !0
                            }), [3, 4];
                          case 3:
                            return r = s.sent(), e({
                              continued: !1,
                              err: r
                            }), [3, 4];
                          case 4:
                            return [3, 6];
                          case 5:
                            e({
                              continued: !1,
                              err: n
                            }), s.label = 6;
                          case 6:
                            return [2];
                        }
                      });
                    });
                  }) : e({
                    continued: !1
                  });
                },
                c = function c(t) {
                  var u = t.continued,
                    l = void 0 !== u && u,
                    h = t.err,
                    d = void 0 === h ? null : h;
                  if (l) setTimeout(function () {
                    return a(c);
                  }, 10);else if (d) mt.error(d.message), o._globalMutex.unlock(), o._event.error(d), n(d);else {
                    var f = [];
                    i.collectionNames.forEach(function (e) {
                      o._collections.has(e) || f.push(r(o, void 0, void 0, function () {
                        var t, n;
                        return s(this, function (r) {
                          switch (r.label) {
                            case 0:
                              return [4, ot.metadataOf(this.name, e, this._store)];
                            case 1:
                              return (t = r.sent()) ? (n = new ot({
                                dbname: this.name,
                                collectionName: e,
                                keyName: t.keyName,
                                indexes: t.indexes,
                                store: this._store
                              }), this._collections.set(e, n), [4, n.init()]) : [3, 3];
                            case 2:
                              r.sent(), r.label = 3;
                            case 3:
                              return [2];
                          }
                        });
                      }));
                    }), Promise.all(f).then(function () {
                      o._state = _t.OPENED, o._globalMutex.unlock(), o._event.success(), e();
                    }).catch(function (e) {
                      mt.error(e.message), o._globalMutex.unlock(), o._event.error(e), n(e);
                    });
                  }
                };
              a(c);
            })];
          case 5:
            switch (a = c.sent(), a.code) {
              case Ee.STORE_NOT_AVAILABLE_IN_PRIVATE_BROWSING:
                return [3, 6];
              case Ee.STORE_NOT_AVAILABLE:
                return [3, 8];
              case Ee.STORE_ENCRYPTION_INVALID:
                return [3, 10];
            }
            return [3, 13];
          case 6:
            return mt.warning("Access to the local storage is not allowed. Switched to MemoryStore automatically."), this._store = new lt({}), this._globalMutex.unlock(), this._event.error(a), this._event.storeReplaced(this._store), [4, this.open()];
          case 7:
            return c.sent(), [3, 14];
          case 8:
            return mt.warning("IndexedDB is not available in this environment. Switched to MemoryStore automatically. Consider using other store to save data persistently (e.g. AsyncStorage)."), this._store = new lt({}), this._globalMutex.unlock(), this._event.error(a), this._event.storeReplaced(this._store), [4, this.open()];
          case 9:
            return c.sent(), [3, 14];
          case 10:
            return mt.warning("Encryption algorithm has changed. Stored data would be cleared."), [4, this._store.clear()];
          case 11:
            return c.sent(), this._globalMutex.unlock(), this._event.error(a), [4, this.open()];
          case 12:
            return c.sent(), [3, 14];
          case 13:
            throw mt.error(a.message), this._globalMutex.unlock(), this._event.error(a), a;
          case 14:
            return [3, 15];
          case 15:
            return [2];
        }
        var u;
      });
    });
  }, e.prototype.close = function () {
    this._collections.forEach(function (e) {
      return e.close();
    }), this._state = _t.CLOSED;
  }, e.prototype.clear = function () {
    return r(this, void 0, void 0, function () {
      return s(this, function (e) {
        switch (e.label) {
          case 0:
            return [4, Promise.all(Array.from(this._collections.values()).map(function (e) {
              return e.clear();
            }))];
          case 1:
            return e.sent(), [2];
        }
      });
    });
  }, e.prototype.reset = function () {
    return r(this, void 0, void 0, function () {
      var e,
        t = this;
      return s(this, function (n) {
        switch (n.label) {
          case 0:
            return this.close(), (e = tt.get(this.name)) && e.clearByCondition(function (e) {
              return e.key.startsWith(ze(t.name));
            }), [4, this._store.clear()];
          case 1:
            return n.sent(), [2];
        }
      });
    });
  }, e.prototype.on = function (e, t) {
    this._event[e] = t;
  }, e.prototype.off = function (e) {
    if ("function" == typeof this._event[e]) if ("upgrade" === e) this._event[e] = Ue;else this._event[e] = Me;
  }, e.prototype.collection = function (e) {
    var t = this._collections.get(e);
    if (t) return t;
    throw Se.collectionNotReady;
  }, e;
}();
export { ft as A, be as D, j as G, dt as I, W as M, ce as N, G as P, we as R, ie as S, Ae as U, X as a, ue as b, lt as c, pe as d, te as e, ye as f, Y as g, yt as h, fe as i, he as j, _t as k, Ie as l, Ne as m, me as n, _e as o, Q as p, ae as q, oe as r, ge as s, z as t, se as v };